// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "\u5177\u6709\u8BE5\u540D\u79F0\u7684\u5E03\u5C40\u5DF2\u5B58\u5728",
  ACCEPT: "\u63A5\u53D7",
  ACCEPT_ALL: "\u5168\u90E8\u63A5\u53D7",
  ACCEPT_REJECT_TRANSFER_PENDING: "\u6279\u51C6\u5F85\u5B9A",
  ACCEPTED: "\u5DF2\u63A5\u53D7",
  ACCOUNT: "\u5E10\u6237",
  ACCOUNT_ADDRESS: "\u5E10\u6237\u5730\u5740",
  ACCOUNT_COUNTRY: "\u5E10\u6237\u6240\u5728\u56FD\u5BB6",
  ACCOUNT_END: "\u5E10\u6237\u7ED3\u675F",
  ACCOUNT_NAME: "\u5E10\u6237\u540D\u79F0",
  ACCOUNT_NUMBER: "\u5E10\u53F7",
  ACCOUNT_NUMBER_REQUIRED: "\u987B\u6709\u5E10\u53F7",
  ACCOUNTS: "\u5E10\u6237",
  ACCUMULATED_DAYS_ON_RENT: "\u7D2F\u79EF\u51FA\u79DF\u7684\u5929\u6570",
  ACCUMULATED_DAYS_RENTED: "\u7D2F\u79EF\u51FA\u79DF\u7684\u5929\u6570",
  ACTIONS: "\u64CD\u4F5C",
  ACTIVE_WARRANTY: "\u6709\u6548\u4FDD\u4FEE",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "\u6709\u6548\u4FDD\u4FEE\uFF08\u5355\u51FB\u4E86\u89E3\u8BE6\u60C5\uFF09",
  ACTUAL_AUDIT: "\u5B9E\u9645\u5BA1\u8BA1",
  ACTUAL_AUDIT_DATE: "\u5B9E\u9645\u5BA1\u8BA1\u65E5\u671F",
  ACTUAL_COURIER_NAME: "\u5B9E\u9645\u627F\u8FD0\u5546\u540D\u79F0",
  ACTUAL_HOURS: "\u5B9E\u9645\u5C0F\u65F6\u6570",
  ADD_CLAIM: "\u6DFB\u52A0\u7D22\u8D54",
  ADD_CLAIMS: "\u6DFB\u52A0\u7D22\u8D54",
  ADD_COMPONENT: "\u6DFB\u52A0\u90E8\u4EF6",
  ADD_OPTION: "\u6DFB\u52A0\u9009\u9879",
  ADD_REP: "\u9644\u52A0\u4FEE\u7406",
  ADD_TO_AUDIT: "\u6DFB\u52A0\u81F3\u5BA1\u8BA1",
  ADDITIONAL: "\u5176\u4ED6",
  ADDITIONAL_COMMENTS: "\u9644\u52A0\u5907\u6CE8",
  ADDITIONAL_REPAIR: "\u9644\u52A0\u4FEE\u7406",
  ADDITIVE: "\u8865\u8D34",
  ADDRESS: "\u5730\u5740",
  ADDRESS_LINE1: "\u5730\u5740\u884C1",
  ADDRESS_LINE1_REQUIRED: "\u9700\u8981\u5730\u5740\u884C1",
  ADDRESS_LINE2: "\u5730\u5740\u884C2",
  ADJ_CLM: "\u8C03\u6574\u7D22\u8D54",
  ADJUST_CLAIM: "\u8C03\u6574\u7D22\u8D54",
  ADJUSTED_HOURS: "\u8C03\u6574\u540E\u7684\u5C0F\u65F6\u6570",
  ADJUSTED_QUANTITY: "\u8C03\u6574\u6570\u91CF",
  ADJUSTMENT_TYPE: "\u8C03\u6574\u7C7B\u578B",
  ADVANCED_CLAIM_SUMMARY: "\u9AD8\u7EA7\u6458\u8981\u7D22\u8D54",
  AFTER_DELIVERY_INSPECTION: "\u4EA4\u4ED8\u540E\u68C0\u67E5",
  AGENCY_NAME: "\u6D3E\u51FA\u6240\u540D\u79F0",
  ALL: "\u5168\u90E8",
  ALL_ACCOUNTS: "\u6240\u6709\u5E10\u6237",
  ALL_CLAIMS: "\u5168\u90E8\u7D22\u8D54",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "\u6240\u6709\u7D22\u8D54\u90FD\u8981\u63A5\u53D7\u5BA1\u67E5\uFF08\u8BE6\u7EC6\u4FE1\u606F\uFF0C\u53C2\u89C1JD WAM 110.08\uFF09",
  ALL_CLAIMS_TAB: "\u6240\u6709\u7D22\u8D54 ({count, number})",
  ALL_PART_REQUESTS: "\u6240\u6709\u96F6\u4EF6\u8BF7\u6C42",
  ALL_PART_REQUESTS_WITH_COUNT: "\u6240\u6709\u96F6\u4EF6\u8BF7\u6C42 ({count})",
  ALL_PARTS_RETURNED: "\u5DF2\u8FD4\u56DE\u6240\u6709\u96F6\u4EF6",
  AMOUNT: "\u91D1\u989D",
  AMOUNT_1: "\u91D1\u989D 1",
  AMOUNT_2: "\u91D1\u989D 2",
  AMOUNT_3: "\u91D1\u989D 3",
  AMOUNT_OF_USE: "\u4F7F\u7528\u91CF",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "\u4F7F\u7528\u91CF\u5386\u53F2\u8BB0\u5F55 ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7528\u91CF",
  AMOUNT_OF_USE_REQUIRED: "\u4F7F\u7528\u91CF\u5FC5\u586B",
  AMOUNT_OF_USE_UNITS_REQUIRED: "\u4F7F\u7528\u91CF\u5355\u4F4D\u5FC5\u586B",
  AMOUNT_RECORDED: "\u8BB0\u5F55\u7684\u4F7F\u7528\u91CF",
  AMOUNT_TO_BE_DEBITED: "\u8981\u501F\u8BB0\u7684\u91D1\u989D",
  APLYPIP: "\u7533\u8BF7 PIP",
  APPLICATION: "\u7528\u9014",
  APPLICATION_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7528\u9014",
  APPLY: "\u5E94\u7528",
  APPLY_TRAVEL: "\u7533\u8BF7\u5DEE\u65C5",
  APPROVAL_DEALER_COMMENTS: "\u6279\u51C6\u7ECF\u9500\u5546\u5907\u6CE8",
  APPROVAL_DETAILS: "\u6279\u51C6\u8BE6\u60C5",
  APPROVAL_LEVELS: "\u6279\u51C6\u7EA7\u522B",
  APPROVAL_REMARKS: "\u6279\u51C6\u5907\u6CE8",
  APPROVAL_STATUS: "\u5BA1\u6279\u72B6\u6001",
  APPROVE: "\u6279\u51C6",
  APPROVE_LABOR_RATE: "\u6279\u51C6\u4EBA\u5DE5\u8D39\u7387",
  APPROVE_MACHINE_STATUS_UPDATE: "\u6279\u51C6\u673A\u5668\u72B6\u6001\u66F4\u65B0",
  APPROVE_PIP_CODE_REQUEST: "\u6279\u51C6 PIP\u4EE3 \u7801\u8BF7\u6C42",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "\u6279\u51C6\u7279\u6B8A\u7D22\u8D54",
  APPROVED: "\u6279\u51C6",
  APPROVED_CORE_VALUE: "\u6279\u51C6\u7684\u6838\u5FC3\u4EF7\u503C\u91D1\u989D",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "\u6279\u51C6\u65E5\u671F\u4E0D\u53EF\u65E9\u4E8E\u8BBE\u7F6E\u65E5\u671F",
  APPROVED_DIAGNOSTIC_AMOUNT: "\u6279\u51C6\u7684\u8BCA\u65AD\u91D1\u989D",
  APPROVED_DIAGNOSTIC_HOURS: "\u6279\u51C6\u7684\u8BCA\u65AD\u65F6\u95F4",
  APPROVED_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6279\u51C6\u65E5\u671F",
  APPROVED_LABOR_ADDITIVE: "\u6279\u51C6\u7684\u5DE5\u65F6\u8865\u8D34",
  APPROVED_LABOR_AMOUNT: "\u6279\u51C6\u7684\u5DE5\u65F6\u8D39",
  APPROVED_LABOR_HOURS: "\u6279\u51C6\u7684\u5DE5\u65F6",
  APPROVED_LABOR_TOTAL: "\u6279\u51C6\u7684\u4EBA\u5DE5\u603B\u8BA1",
  APPROVED_ON_SHELF_COST: "\u6279\u51C6\u7684\u4E0A\u67B6\u6210\u672C",
  APPROVED_OTHER_CREDITS: "\u6279\u51C6\u7684\u5176\u4ED6\u8D54\u4ED8",
  APPROVED_PARTS: "\u6279\u51C6\u7684\u96F6\u4EF6",
  APPROVED_PARTS_ADDITIVE: "\u6279\u51C6\u7684\u96F6\u4EF6\u8865\u8D34",
  APPROVED_PARTS_TOTAL: "\u6279\u51C6\u7684\u96F6\u4EF6\u603B\u8BA1",
  APPROVED_REJECTED: "\u6279\u51C6/\u62D2\u7EDD",
  APPROVED_REPAIR_AMOUNT: "\u6279\u51C6\u7684\u4FEE\u7406\u91D1\u989D",
  APPROVED_REPAIR_HOURS: "\u6279\u51C6\u7684\u7EF4\u4FEE\u65F6\u95F4",
  APPROVED_TAXES_TOTAL: "\u6279\u51C6\u7684\u7A0E\u6536\u603B\u8BA1",
  APPROVED_TRAVEL_TOTAL: "\u6279\u51C6\u7684\u5DEE\u65C5\u91D1\u989D",
  APPROVER: "\u5BA1\u6279\u4EBA",
  ASCENDING: "\u5347\u5E8F",
  ATTACHMENTS: "\u9644\u4EF6",
  AUDIT_NUMBER: "\u5BA1\u8BA1\u7F16\u53F7",
  AUDIT_PLANNED: "\u8BA1\u5212\u7684\u5BA1\u8BA1",
  AUDIT_REQUIREMENT: "\u5BA1\u8BA1\u8981\u6C42",
  AUDIT_RESULTS: "\u5BA1\u8BA1\u7ED3\u679C",
  AUDIT_STATUS: "\u5BA1\u8BA1\u72B6\u6001",
  AUDIT_SUBMITTED_SUCCESSFULLY: "\u5BA1\u8BA1\u5DF2\u6210\u529F\u63D0\u4EA4",
  AUDIT_SUMMARY: "\u5BA1\u8BA1\u6C47\u603B",
  AUDIT_TYPE: "\u5BA1\u8BA1\u7C7B\u578B",
  AUDITS: "\u5BA1\u8BA1",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} \u5BA1\u8BA1\u5230\u671F",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {audit} other {audits}} \u5728 30 \u5929\u5185\u5230\u671F",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {audit} other {audits}} \u8FC7\u671F",
  AUTHORIZATION_NUMBER: "\u6388\u6743\u53F7",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "\u4ECE\u7ECF\u9500\u5546\u4E1A\u52A1\u7CFB\u7EDF\u81EA\u52A8\u63D0\u4EA4",
  AVAILABLE: "\u53EF\u7528",
  AVAILABLE_COLUMNS: "\u53EF\u7528\u7684\u5217",
  AVERAGE_DIAGNOSTICS_HOURS: "\u5E73\u5747\u8BCA\u65AD\u65F6\u6570",
  AVERAGE_LUG_HEIGHT: "\u5E73\u5747 \u51F8\u8033 \u9AD8\u5EA6",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5E73\u5747\u51F8\u8033\u9AD8\u5EA6",
  AVERAGE_REPAIR_HOURS: "\u5E73\u5747\u4FEE\u7406\u65F6\u6570",
  AVERAGE_REPLACEMENT_HOURS: "\u5E73\u5747\u66F4\u6362\u65F6\u6570",
  AVERAGE_TECH_PAY_RATE: "\u6280\u672F\u4EBA\u5458\u5E73\u5747\u62A5\u916C\u8D39\u7387",
  BACK: "\u8FD4\u56DE",
  BACK_TO_AUDIT: "\u8FD4\u56DE\u5BA1\u8BA1",
  BASE_MACHINE: "\u57FA\u672C\u673A\u5668",
  BASE_MACHINE_IMPLEMENTS: "\u57FA\u672C\u673A\u5668\u519C\u5177",
  BASE_MACHINE_PIN: "\u57FA\u672C\u673A\u5668PIN",
  BASIC_WARRANTY_ENDS: "\u57FA\u672C\u4FDD\u4FEE\u7ED3\u675F",
  BASIC_WARRANTY_ESTIMATOR: "\u9884\u4F30\u57FA\u672C\u4FDD\u4FEE\u671F",
  BASIC_WARRANTY_STARTS: "\u57FA\u672C\u4FDD\u4FEE\u5F00\u59CB",
  BASIS_FOR_SETTLEMENT: "\u7ED3\u7B97\u57FA\u672C\u60C5\u51B5",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "\u7ED3\u7B97\u57FA\u672C\u60C5\u51B5 / \u5BA1\u8BA1\u610F\u89C1",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7ED3\u7B97\u57FA\u672C\u60C5\u51B5",
  BATTERY: "\u7535\u6C60",
  BEGIN_DATE: "\u5F00\u59CB\u65E5\u671F",
  BRANCH: "\u5206\u652F",
  BUILT: "\u5236\u9020\u65E5\u671F",
  BUSINESS_END: "\u4E1A\u52A1\u7ED3\u675F",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "\u8FD9\u53F0\u673A\u5668\u80FD\u5426\u518D\u6B21\u6295\u5165\u4F7F\u7528\uFF1F",
  CANCEL: "\u53D6\u6D88",
  CERTIFIED_LETTER_SENT: "\u6302\u53F7\u4FE1\u5BC4\u9001\u65E5\u671F",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "\u66F4\u6539\u8D1F\u8D23\u7ECF\u9500\u5546",
  CHANGE_STATUS: "\u53D8\u66F4\u72B6\u6001",
  CHANGE_STATUS_FOR: "\u66F4\u6539 {pin} \u7684\u72B6\u6001",
  CHANGED: "\u66F4\u6539",
  CHANGED_BY: "\u66F4\u6539\u4EBA",
  CHANGED_ON: "\u66F4\u6539\u65E5\u671F",
  CHINESE: "\u4E2D\u6587",
  CITY: "\u57CE\u5E02",
  CITY_REQUIRED: "\u6240\u9700\u57CE\u5E02",
  CLAIM: "\u7D22\u8D54",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {\u7D22\u8D54} other {\u7D22\u8D54}})",
  CLAIM_DEBIT: "\u7D22\u8D54\u6263\u6B3E",
  CLAIM_DETAILS: "\u7D22\u8D54\u8BE6\u60C5",
  CLAIM_DRAFT: "\u8349\u7A3F",
  CLAIM_HISTORY: "24\u4E2A\u6708\u7684\u7D22\u8D54\u5386\u53F2\u8BB0\u5F55",
  CLAIM_HISTORY_WITH_COUNT: "24\u4E2A\u6708\u7684\u7D22\u8D54\u5386\u53F2\u8BB0\u5F55 ({count})",
  CLAIM_NUMBER: "\u7D22\u8D54\u53F7",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "\u7D22\u8D54\u641C\u7D22",
  CLAIM_STATUS: "\u7D22\u8D54\u5355\u72B6\u6001",
  CLAIM_TYPE: "\u7D22\u8D54\u7C7B\u578B",
  CLAIM_TYPES: "\u7D22\u8D54\u7C7B\u578B",
  CLAIM_UPDATED_SUCCESSFULLY: "\u7D22\u8D54\u66F4\u65B0\u6210\u529F",
  CLAIM_VALUE: "\u7D22\u8D54\u503C",
  CLAIM_VALUE_DETAILS: "\u7D22\u8D54\u989D\u8BE6\u7EC6\u4FE1\u606F",
  CLAIM_WITH_NUMBER: "\u7D22\u8D54 {claimNumber}",
  CLAIMS: "\u7D22\u8D54",
  CLAIMS_IN_PROGRESS: "\u7D22\u8D54\u5904\u7406\u4E2D",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "\u7D22\u8D54\u5904\u7406\u4E2D ({count})",
  CLAIMS_OVERVIEW: "\u7D22\u8D54\u6982\u8FF0",
  CLAIMS_OVERVIEW_TAB: "\u7D22\u8D54\u6982\u8FF0 ({count})",
  CLAIMS_WITH_COUNT: "{count} \u7D22\u8D54",
  CLICK_FOR_DETAILS: "\uFF08\u5355\u51FB\u67E5\u770B\u8BE6\u7EC6\u4FE1\u606F\uFF09",
  CLICK_TO_VIEW_ALL: "\u5355\u51FB\u67E5\u770B\u6240\u6709\u5185\u5BB9",
  CLOSE: "\u5173\u95ED",
  CLOSED_PART_REQUESTS: "\u5C01\u95ED\u7684\u90E8\u5206\u8BF7\u6C42",
  CLOSING: "\u5173\u95ED",
  CLOSING_ACCOUNT: "\u5173\u95ED\u5E10\u6237",
  CLOSING_ACCOUNT_WITH_COUNT: "\u5173\u95ED\u5E10\u6237\uFF08{count}\uFF09",
  CODE: "\u4EE3\u7801",
  COLLAPSE_ALL: "\u5168\u90E8\u6298\u53E0",
  COMMENT: "\u5907\u6CE8",
  COMMENTS: "\u5907\u6CE8",
  COMMENTS_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5907\u6CE8",
  COMMENTS_TO_DEALER: "\u5199\u7ED9\u7ECF\u9500\u5546\u7684\u5907\u6CE8",
  COMMON_LABOR_TYPES_WARNING: "\u5E76\u975E\u6240\u6709\u7684\u4EBA\u5DE5\u7C7B\u578B\u90FD\u53EF\u7528\u4E8E\u6240\u9009\u5E10\u6237",
  COMPANY: "\u8FEA\u5C14\u516C\u53F8",
  COMPANY_CONTRIBUTION: "\u8FEA\u5C14\u516C\u53F8\u5206\u644A\u91D1\u989D",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u8FEA\u5C14\u516C\u53F8\u5206\u644A\u91D1\u989D",
  COMPLAINT_CAUSE: "\u95EE\u9898\u4EA7\u751F\u7684\u539F\u56E0\u662F\u4EC0\u4E48\uFF1F",
  COMPLAINT_CAUSE_IS_REQUIRED: "\u5FC5\u9700\u586B\u5199\u95EE\u9898\u539F\u56E0",
  COMPLAINT_CORRECTION: "\u95EE\u9898\u662F\u600E\u6837\u89E3\u51B3\u7684\uFF1F",
  COMPLAINT_CORRECTION_IS_REQUIRED: "\u5FC5\u9700\u586B\u5199\u95EE\u9898\u89E3\u51B3\u65B9\u6CD5",
  COMPLETE: "\u5B8C\u6210",
  COMPLETED: "\u5B8C\u6210\u65E5\u671F",
  COMPLETED_BY: "\u5B8C\u6210\u8005",
  COMPLETED_DATE: "\u5B8C\u6210\u65E5\u671F",
  COMPLETED_IN_LAST_24_MONTHS: "\u5728\u8FC7\u53BB 24 \u4E2A\u6708\u5B8C\u6210",
  COMPLETION_STATUS: "\u5B8C\u6210\u72B6\u6001",
  COMPONENT: "\u90E8\u4EF6",
  COMPONENT_CODE: "\u90E8\u4EF6\u4EE3\u7801",
  COMPONENT_CREATED_SUCCESSFULLY: "\u90E8\u4EF6\u521B\u5EFA\u6210\u529F",
  COMPONENT_DELETED_SUCCESSFULLY: "\u90E8\u4EF6\u5220\u9664\u6210\u529F",
  COMPONENT_SERIAL_NUMBER: "\u90E8\u4EF6\u5E8F\u5217\u53F7",
  COMPONENT_SUCCESSFULLY_UPDATED: "\u90E8\u4EF6\u66F4\u65B0\u6210\u529F",
  COMPONENTS: "\u90E8\u4EF6",
  CONFIRM: "\u786E\u8BA4",
  CONFIRM_ADDITIONAL_REPAIR: "\u662F\u5426\u786E\u5B9A\u8981\u6DFB\u52A0\u989D\u5916\u7EF4\u4FEE\uFF1F",
  CONFIRM_ADJUST_CLAIM: "\u662F\u5426\u786E\u5B9A\u8981\u8C03\u6574\u6B64\u7D22\u8D54\uFF1F",
  CONFIRM_CLOSING_ACCOUNT: "\u662F\u5426\u786E\u5B9A\u8981\u63A5\u53D7\u6B64\u8F6C\u79FB\uFF1F",
  CONFIRM_COPY_CLAIM: "\u662F\u5426\u786E\u5B9A\u8981\u590D\u5236\u6B64\u7D22\u8D54\uFF1F",
  CONFIRM_DELETE_ATTACHMENT: "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u9644\u4EF6\u5417\uFF1F",
  CONFIRM_DELETE_CLAIM: "\u662F\u5426\u786E\u5B9A\u8981\u5220\u9664\u6B64\u7D22\u8D54\uFF1F",
  CONFIRM_DELETE_REGISTRATION: "\u662F\u5426\u786E\u5B9A\u8981\u5220\u9664\u6B64\u6CE8\u518C\uFF1F",
  CONFIRM_EDIT_CLAIM: "\u60A8\u8981\u7F16\u8F91\u6B64\u58F0\u660E\u5417\uFF1F",
  CONFIRM_RECONCILE_CLAIM: "\u662F\u5426\u786E\u5B9A\u8981\u6838\u9500\u6B64\u7D22\u8D54\uFF1F",
  CONFIRM_RESEND_XML: "\u662F\u5426\u786E\u5B9E\u8981\u91CD\u65B0\u53D1\u9001XML?\u8BF7\u572824-48\u5C0F\u65F6\u4E4B\u95F4\u663E\u793A\u3002",
  CONFIRM_SKIP_AUDIT: "\u60A8\u786E\u5B9A\u8981\u8DF3\u8FC7\u6B64\u5BA1\u6838\u5417\uFF1F",
  CONFIRM_UNDO_REGISTRATION: "\u662F\u5426\u786E\u5B9A\u8981\u64A4\u6D88\u6B64\u6CE8\u518C\uFF1F",
  CONTACTED: "\u8054\u7CFB\u65E5\u671F",
  CONTAINS: "\u5305\u62EC",
  CONTRACT_NUMBER: "\u5408\u540C\u7F16\u53F7",
  CONTRACT_PURCHASED: "\u5408\u540C\u8D2D\u4E70\u65E5\u671F",
  CONTRACT_TYPE: "\u5408\u540C\u7C7B\u578B",
  COPY_CLAIM: "\u590D\u5236\u7D22\u8D54",
  CORE: "\u6838\u5FC3",
  CORE_VALUE: "\u6838\u5FC3\u503C",
  COUNTRY: "\u56FD\u5BB6",
  COUNTRY_REQUIRED: "\u6240\u9700\u56FD\u5BB6/\u5730\u533A",
  COURIER_ACCOUNT_NUMBER: "\u627F\u8FD0\u5546\u5E10\u53F7",
  COURIER_NAME: "\u627F\u8FD0\u5546\u540D\u79F0",
  COVERAGE_DECISION: "\u8986\u76D6\u8303\u56F4\u51B3\u5B9A",
  COVERAGE_TYPE: "\u8986\u76D6\u8303\u56F4\u7C7B\u578B",
  CRDMEM: "\u7ED3\u7B97\u5355",
  CREATE: "\u521B\u5EFA",
  CREATE_CLAIM: "\u521B\u5EFA\u7D22\u8D54",
  CREATE_LAYOUT: "\u521B\u5EFA\u5E03\u5C40",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "\u63D0\u51FA\u6709\u5173\u672C\u4EA7\u54C1\u7684\u7D22\u8D54\u524D\uFF0C\u8BF7\u63D0\u4F9B\u76F8\u5173\u91CD\u8981\u4FE1\u606F",
  CREATE_PIP_CLAIM: "\u521B\u5EFA PIP \u7D22\u8D54",
  CREATE_PIP_CLAIMS: "\u521B\u5EFA PIP \u7D22\u8D54",
  CREATE_PRODUCT_RECORD: "\u521B\u5EFA\u4EA7\u54C1\u8BB0\u5F55",
  CREATE_REQUEST: "\u521B\u5EFA\u8BF7\u6C42",
  CREATE_TRANSFER_PENDING: "\u8F6C\u79FB\u5F85\u5904\u7406",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "\u521B\u5EFA\u79FB\u4EA4\u670D\u52A1\u4E0D\u53EF\u7528",
  CREATED: "\u521B\u5EFA",
  CREATED_BY: "\u521B\u5EFA\u4EBA",
  CREATED_DATE: "\u521B\u5EFA\u65E5\u671F",
  CREATED_ON: "\u521B\u5EFA\u4E8E",
  CREATION_DATE: "\u521B\u5EFA\u65E5\u671F",
  CREDIT_MEMO: "\u7ED3\u7B97\u5355",
  CREDIT_MEMO_DATE: "\u7ED3\u7B97\u5355\u65E5\u671F",
  CREDIT_MEMO_ISSUE_DATE: "\u7ED3\u7B97\u5355\u53D1\u5E03\u65E5\u671F",
  CREDIT_MEMO_NUMBER: "\u7ED3\u7B97\u5355\u53F7",
  CREDIT_MEMO_PROCESS_DATE: "\u7ED3\u7B97\u5355\u5904\u7406\u65E5\u671F",
  CREDIT_MEMO_SELECTED: "\u5DF2\u9009\u7ED3\u7B97\u5355",
  CREDIT_MEMOS: "\u7ED3\u7B97\u5355",
  CRITERIA: "\u6807\u51C6",
  CRT: "\u521B\u5EFA",
  CSV_SEPARATOR: "CSV\u5206\u9694\u7B26",
  CURRENCY: "\u8D27\u5E01",
  CURRENT: "\u5F53\u524D",
  CURRENT_ACCOUNT: "\u5F53\u524D\u5E10\u6237",
  CURRENT_AMOUNT_OF_USE: "\u5F53\u524D\u4F7F\u7528\u91CF",
  CURRENT_CUSTOMER: "\u5F53\u524D\u5BA2\u6237",
  CURRENT_DEALER: "\u5F53\u524D\u7ECF\u9500\u5546",
  CURRENT_DEALER_DISTANCE: "\u5F53\u524D\u7ECF\u9500\u5546\u8DDD\u79BB",
  CURRENT_DEALER_LAST_SERVICE_DATE: "\u5F53\u524D\u4EA4\u6613\u5546\u4E0A\u6B21\u670D\u52A1\u65E5\u671F",
  CURRENT_DEALER_LOCATION: "\u5F53\u524D\u7ECF\u9500\u5546\u5730\u70B9",
  CURRENT_HOURS: "\u5F53\u524D\u5C0F\u65F6\u6570",
  CURRENT_QUANTITY: "\u5F53\u524D\u6570\u91CF",
  CURRENT_RESPONSIBLE_DEALER: "\u5F53\u524D\u8D1F\u8D23\u7684\u7ECF\u9500\u5546",
  CURRENT_VALUES: "\u5F53\u524D\u503C",
  CURRENTLY_ON_RENT: "\u6B63\u5728\u79DF\u8D41",
  CUSTOM_RANGE: "\u81EA\u5B9A\u4E49\u8303\u56F4",
  CUSTOM_VALUES: "\u81EA\u5B9A\u4E49\u503C",
  CUSTOMER: "\u5BA2\u6237",
  CUSTOMER_CONTRIBUTION: "\u5BA2\u6237\u5206\u644A\u91D1\u989D",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5BA2\u6237\u5206\u644A\u91D1\u989D",
  CUSTOMER_CREATED_SUCCESSFULLY: "\u5BA2\u6237\u521B\u5EFA\u6210\u529F",
  CUSTOMER_DETAILS: "\u5BA2\u6237\u8BE6\u60C5",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "\u5BA2\u6237\u8BE6\u7EC6\u4FE1\u606F\u66F4\u65B0\u6210\u529F",
  CUSTOMER_INFORMATION: "\u5BA2\u6237\u4FE1\u606F",
  CUSTOMER_INFORMATION_IS_REQUIRED: "\u5BA2\u6237\u4FE1\u606F\u662F\u5FC5\u9700\u7684\u3002",
  CUSTOMER_INVALID: "\u65E0\u6CD5\u627E\u5230\u6216\u521B\u5EFA\u5BA2\u6237\uFF0C\u8BF7\u641C\u7D22\u5BA2\u6237",
  CUSTOMER_NAME: "\u5BA2\u6237\u540D\u79F0",
  CUSTOMER_NAME_IS_REQUIRED: "\u5BA2\u6237\u4FE1\u606F\u662F\u5FC5\u9700\u7684\u3002",
  CUSTOMER_NOT_FOUND: "\u5BA2\u6237\u672A\u627E\u5230",
  CUSTOMER_REQUIRED: "\u5BA2\u6237\u5FC5\u586B",
  CUSTOMER_RESOLUTION: "\u5BA2\u6237\u89E3\u51B3\u65B9\u6848",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5BA2\u6237\u89E3\u51B3\u65B9\u6848",
  CUSTOMER_SEARCH: "\u5BA2\u6237\u641C\u7D22",
  CUSTOMER_UPDATED_SUCCESSFULLY: "\u5BA2\u6237\u66F4\u65B0\u6210\u529F",
  DAMAGED_MACHINES_HELP_TEXT: "\u5BF9\u4E8E\u635F\u574F\u7684\u673A\u5668\uFF0C\u5176\u4FDD\u4FEE\u5C06\u81EA\u52A8\u6682\u505C\uFF0C\u9700\u7B49 TCSM \u5BA1\u6838\u3001\u6279\u51C6\u672C\u8868\u683C\u5B8C\u6BD5\u4E4B\u540E\u65B9\u53EF\u6062\u590D\u4FDD\u4FEE\u3002\u635F\u574F\u7684\u673A\u5668\u4EC5\u6709\u8D44\u683C\u53C2\u52A0\u201C\u5F3A\u5236\u6027 \u6545\u969C\u4E0E\u5B89\u5168\u201D\u4EA7\u54C1\u6539\u8FDB\u8BA1\u5212 (PIP)\u3002",
  DATE: "\u65E5\u671F",
  DATE_FORMAT: "\u65E5\u671F\u683C\u5F0F",
  DATE_ISSUED: "\u53D1\u5E03\u65E5\u671F",
  DATE_OF_CERTIFIED_LETTER: "\u6302\u53F7\u4FE1\u65E5\u671F",
  DATE_OF_EVENT_CAUSING_DAMAGE: "\u5BFC\u81F4\u673A\u5668\u635F\u574F\u7684\u4E8B\u4EF6\u53D1\u751F\u65E5\u671F",
  DATE_OF_LAST_PERSONAL_CONTACT: "\u6700\u540E\u4E00\u6B21\u8054\u7CFB\u65E5\u671F",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "\u96F6\u4EF6\u53D1\u8D27\u65E5\u671F",
  DATE_REFUSED: "\u62D2\u7EDD\u65E5\u671F",
  DATE_SUBMITTED: "\u63D0\u4EA4\u65E5\u671F",
  DAYS_FROM_REGISTRATION: "\u8DDD\u79BB\u6CE8\u518C\u7684\u5929\u6570",
  DAYS_LEFT: "\u5269\u4F59\u5929\u6570",
  DAYS_LEFT_WITH_COUNT: "\u5269\u4F59 {daysToDisplay} \u5929",
  DAYS_ON_RENT: "\u79DF\u8D41\u7684\u5929\u6570",
  DAYS_REMAINING: "\u5269\u4F59\u5929\u6570",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} \u4FDD\u7559",
  DAYS_TO_DISPLAY: "\u8981\u663E\u793A\u7684\u5929\u6570",
  DBS: "\u7ECF\u9500\u5546\u4E1A\u52A1\u7CFB\u7EDF",
  DEALER: "\u7ECF\u9500\u5546",
  DEALER_ACCOUNT: "\u7ECF\u9500\u5546\u5E10\u6237",
  DEALER_ACCOUNT_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7ECF\u9500\u5546\u8D26\u6237",
  DEALER_ACCOUNTS: "\u7ECF\u9500\u5546\u5E10\u6237",
  DEALER_CITY: "\u7ECF\u9500\u5546\u57CE\u5E02",
  DEALER_COMMENTS: "\u7ECF\u9500\u5546\u5907\u6CE8",
  DEALER_CONTRIBUTION: "\u7ECF\u9500\u5546\u5206\u644A\u91D1\u989D",
  DEALER_CONTRIBUTION_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7ECF\u9500\u5546\u5206\u644A\u91D1\u989D",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "\u7ECF\u9500\u5546\u53D1\u7968\u53F7",
  DEALER_INVOICE_UPDATED: "\u7ECF\u9500\u5546\u53D1\u7968\u5DF2\u66F4\u65B0",
  DEALER_INVOICE_UPDATES: "\u7ECF\u9500\u5546\u53D1\u7968",
  DEALER_INVOICES: "\u7ECF\u9500\u5546\u53D1\u7968",
  DEALER_LOCATION: "\u7ECF\u9500\u5546\u5730\u70B9",
  DEALER_LOCATION_FILTER: "\u7B5B\u9009\u5730\u70B9",
  DEALER_LOCATION_IS_REQUIRED: "\u8BF7\u9009\u62E9\u7ECF\u9500\u5546\u8D26\u53F7",
  DEALER_LOCATIONS: "\u7ECF\u9500\u5546\u5730\u70B9",
  DEALER_NAME: "\u7ECF\u9500\u5546\u540D\u79F0",
  DEALER_PHONE: "\u7ECF\u9500\u5546\u7535\u8BDD\u53F7\u7801",
  DEALER_POSTAL_CODE: "\u90AE\u653F\u7F16\u7801",
  DEALER_RECOMMENDATIONS: "\u7ECF\u9500\u5546\u63A8\u8350",
  DEALER_RECOMMENDATIONS_TAB: "\u7ECF\u9500\u5546\u5EFA\u8BAE ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "\u4EA4\u6613\u5546\u5DF2\u6210\u529F\u5BA1\u67E5",
  DEALER_SEARCH: "\u7ECF\u9500\u5546\u641C\u7D22",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "\u8F93\u5165\u540D\u79F0\u3001\u57CE\u5E02\u6216\u5E10\u6237\u6765\u641C\u7D22\u7ECF\u9500\u5546",
  DEALER_STATE: "\u7ECF\u9500\u5546\u5DDE/\u7701",
  DEALER_SUBMISSION_WITH_CURRENCY: "\u7ECF\u9500\u5546\u63D0\u4EA4 ({currency})",
  DEALER_TRANSFER_HISTORY: "\u7ECF\u9500\u5546\u53D8\u66F4\u5386\u53F2",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "\u7ECF\u9500\u5546\u4F20\u8F93\u8BF7\u6C42\u5DF2\u6210\u529F\u6392\u961F",
  DEALER_WARRANTY: "\u7ECF\u9500\u5546\u4FDD\u4FEE",
  DEALERS: "\u7ECF\u9500\u5546",
  DEALERSHIP: "\u7ECF\u9500\u5546",
  DEBIT: "\u6263\u6B3E",
  DEBIT_AMOUNT: "\u6263\u6B3E\u91D1\u989D",
  DEBIT_FOR_CLAIM_NUMBER: "\u6263\u6B3E\u7684\u7D22\u8D54\u5355{claimNumber}",
  DEBIT_REQUIRED: "\u9700\u6263\u6B3E",
  DEBIT_REQUIRED_STATUS: "\u9700\u6263\u6B3E\u72B6\u6001",
  DEBIT_SUBMITTED_SUCCESSFULLY: "\u6263\u6B3E\u5DF2\u6210\u529F\u63D0\u4EA4",
  DEBIT_TYPE: "\u6263\u6B3E\u7C7B\u578B",
  DEBITED: "\u6263\u9664",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "\u5FC5\u9700\u901A\u8FC7\u624B\u52A8\u6263\u6B3E\u6D41\u7A0B\u6765\u5B8C\u6210\u7D22\u8D54\u5355\u6263\u6B3E\u3002",
  DECIMAL_FORMAT: "\u5341\u8FDB\u5236\u683C\u5F0F",
  DECISION_UPDATED: "\u66F4\u65B0\u51B3\u5B9A",
  DECLINE: "\u62D2\u7EDD",
  DEDUCTIBLE: "\u6263\u9664",
  DEERE_REMARKS: "Deere \u5907\u6CE8",
  DEFAULT_WARRANTY: "\u9ED8\u8BA4\u4FDD\u4FEE",
  DEL: "\u5220\u9664",
  DELETE: "\u5220\u9664",
  DELETE_ATTACHMENT: "\u5220\u9664\u9644\u4EF6",
  DELETE_CLAIM: "\u5220\u9664\u7D22\u8D54",
  DELETE_REGISTRATION: "\u5220\u9664\u6CE8\u518C",
  DELETE_REGISTRATION_SUCCESS: "\u6CE8\u518C\u6210\u529F\u5220\u9664",
  DELETED: "\u5220\u9664",
  DELETED_BY: "\u5220\u9664\u4EBA",
  DELIVERED: "\u7528\u6237\u63D0\u8F66\u65E5\u671F",
  DELIVERED_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7528\u6237\u63D0\u8F66\u65E5\u671F",
  DELIVERY_DATE: "\u7528\u6237\u63D0\u8F66\u65E5\u671F",
  DELIVERY_DATE_REQUIRED: "\u7528\u6237\u63D0\u8F66\u65E5\u671F\u5FC5\u9700",
  DELIVERY_DATES: "\u7528\u6237\u63D0\u8F66\u65E5\u671F",
  DELIVERY_NO_DOCUMENTS: "\u7528\u6237\u5DF2\u63D0\u8F66\uFF0C\u65E0\u6587\u6863\u8BB0\u5F55",
  DEMO_RENTAL_BEGIN_DATE: "\u6F14\u793A/\u79DF\u8D41\u5F00\u59CB\u65E5\u671F",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "\u9009\u62E9\u7ECF\u9500\u5546\u548C\u72B6\u6001",
  DEMO_RENTAL_END_DATE: "\u6F14\u793A/\u79DF\u8D41\u7ED3\u675F\u65E5\u671F",
  DEMO_RENTAL_HISTORY: "\u6F14\u793A\u79DF\u8D41\u5386\u53F2\u8BB0\u5F55",
  DENY: "\u62D2\u7EDD",
  DENY_MACHINE_STATUS_UPDATE: "\u62D2\u7EDD\u673A\u5668\u72B6\u6001\u66F4\u65B0",
  DENY_PIP_CODE_REQUEST: "\u62D2\u7EDD PIP\u4EE3\u7801\u7533\u8BF7",
  DESCENDING: "\u964D\u5E8F",
  DESCRIPTION: "\u63CF\u8FF0",
  DESCRIPTION_OF_DAMAGE: "\u635F\u574F\u8BF4\u660E",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "\u5BFC\u81F4\u673A\u5668\u635F\u574F\u7684\u4E8B\u4EF6\u8BF4\u660E",
  DESELECT_ALL: "\u53D6\u6D88\u9009\u62E9\u5168\u90E8",
  DETAILS: "\u8BE6\u60C5",
  DIAGNOSTICS_COVERED: "\u8D54\u4ED8\u8BCA\u65AD\u5DE5\u65F6",
  DIS_VSR: "\u663E\u793A\u6D88\u606F",
  DISPLAY: "\u663E\u793A",
  DISPLAY_CLAIM: "\u663E\u793A\u7D22\u8D54",
  DISPLAY_CREDIT_MEMO: "\u663E\u793A\u7ED3\u7B97\u5355",
  DISPLAY_FORMAT: "\u663E\u793A\u683C\u5F0F",
  DISPLAY_PRODUCT: "\u663E\u793A\u4EA7\u54C1",
  DISPLAY_TAG: "\u663E\u793A\u96F6\u4EF6\u8FD4\u56DE\u6807\u7B7E",
  DISTANCE: "\u8DDD\u79BB",
  DISTANCE_FROM_CURRENT_DEALER: "\u4E0E\u5F53\u524D\u7ECF\u9500\u5546\u7684\u8DDD\u79BB",
  DISTANCE_FROM_POTENTIAL_DEALER: "\u4E0E\u6F5C\u5728\u4EA4\u6613\u5546\u7684\u8DDD\u79BB",
  DIVISION: "\u5927\u533A",
  DIVISION_SUMMARY: "\u5927\u533A\u603B\u7ED3",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "\u4FDD\u5B58\u6240\u505A\u7684\u66F4\u6539\u5417\uFF1F",
  DOES_NOT_CONTAIN: "\u4E0D\u5305\u62EC",
  DOWNLOAD_TO_EXCEL: "\u4E0B\u8F7D\u5230 Excel",
  DOWNTIME: "\u505C\u673A\u65F6\u95F4",
  DOWNTIME_IS_REQUIRED: "\u505C\u4EA7\u65F6\u95F4\u5FC5\u9700",
  DRAFT: "\u53E6\u5B58\u4E3A\u8349\u7A3F",
  DTAC_CASE: "DTAC \u6848\u4F8B",
  DTAC_CASE_NUMBER: "DTAC \u6848\u4F8B\u7F16\u53F7",
  DTAC_SOLUTION: "DTAC \u89E3\u51B3\u65B9\u6848",
  DUE_DATE: "\u5230\u671F\u65E5\u671F",
  DUE_WITHIN_3_MONTHS: "3 \u4E2A\u6708\u5185\u5230\u671F",
  DUPLICATE_PIN_PLATE: "\u91CD\u590D\u7684PIN\u724C",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "PIN\u724C\u91CD\u590D\u8BF7\u6C42\u5DF2\u66F4\u65B0",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "\u5DF2\u6210\u529F\u521B\u5EFA\u91CD\u590D\u7684PIN\u724C\u8BF7\u6C42",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "\u91CD\u590D\u7684PIN\u724C\u8BF7\u6C42({count})",
  EDIT: "\u7F16\u8F91",
  EDIT_CUSTOMER: "\u7F16\u8F91\u5BA2\u6237",
  EDIT_LAYOUT: "\u7F16\u8F91\u5E03\u5C40",
  EDIT_WITH_PARENTHESES: "(\u7F16\u8F91)",
  EFFECTIVE: "\u6709\u6548",
  EFFECTIVE_DATE: "\u751F\u6548\u65E5\u671F",
  EMAIL: "\u7535\u5B50\u90AE\u4EF6",
  EMISSIONS_PART_SEARCH: "\u6392\u653E\u96F6\u4EF6\u641C\u7D22",
  END_DATE: "\u7ED3\u675F\u65E5\u671F",
  END_USE: "\u6700\u7EC8\u7528\u9014",
  END_USE_CODE: "\u6700\u7EC8\u7528\u9014\u4EE3\u7801",
  END_USE_CODE_REQUIRED: "\u6700\u7EC8\u7528\u9014\u4EE3\u7801\u5FC5\u586B",
  ENDS_WITH: "\u7ED3\u675F\u4E8E",
  ENGLISH: "\u82F1\u8BED",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "\u8F93\u5165 0 \u5230 1000 \u4E4B\u95F4\u7684\u6570\u5B57",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "\u8F93\u5165\u4ECB\u4E8E 0 \u4E0E 10000 \u4E4B\u95F4\u7684\u4E00\u4E2A\u6570\u5B57",
  ENTER_A_NUMBER_FROM_1_TO_9999: "\u8F93\u5165 1 \u5230 9999 \u4E4B\u95F4\u7684\u6570\u5B57",
  ENTER_A_PART_NUMBER: "\u8F93\u5165\u96F6\u4EF6\u53F7",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "\u63A5\u53D7\u4E4B\u524D\u8F93\u5165\u6CE8\u91CA",
  EQUALS: "\u7B49\u4E8E",
  ERROR: "\u9519\u8BEF\uFF1A",
  ERROR_MESSAGE_TITLE: "\u51FA\u73B0\u4E00\u4E2A\u9519\u8BEF\uFF1A",
  ERROR_MESSAGES: "\u9519\u8BEF\u6D88\u606F",
  ERROR_MESSAGES_TITLE: "\u51FA\u73B0\u591A\u4E2A\u9519\u8BEF\uFF1A",
  ERROR_NETWORK_ISSUES: "\u4E00\u4E2A\u7F51\u7EDC\u9519\u8BEF\u963B\u6B62\u4E86\u90E8\u5206\u6570\u636E\u52A0\u8F7D \u2014 \u8BF7\u91CD\u8BD5",
  ERROR_NO_DATA_TO_EXPORT: "\u65E0\u8981\u5BFC\u51FA\u7684\u6570\u636E",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "\u68C0\u7D22\u5BA2\u6237\u4FE1\u606F\u65F6\u51FA\u9519",
  ERROR_SAP: "\u65E0\u6CD5\u8FDE\u63A5\u5230\u670D\u52A1\u5668\u3002\u5982\u679C\u95EE\u9898\u6301\u7EED\u5B58\u5728\uFF0C\u8BF7\u4F7F\u7528\u201C\u8054\u7CFB\u6211\u4EEC\u201D\u94FE\u63A5\u5BFB\u6C42\u5E2E\u52A9\uFF0C\u4EE5\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002",
  ERROR_SESSION: "\u60A8\u7684\u4F1A\u8BDD\u5DF2\u5230\u671F\u3002\u5237\u65B0\u9875\u9762\u4EE5\u91CD\u65B0\u767B\u5F55\u3002",
  ERROR_UNHANDLED: "\u7CFB\u7EDF\u51FA\u73B0\u610F\u5916\u9519\u8BEF\u3002\u5982\u679C\u95EE\u9898\u6301\u7EED\u5B58\u5728\uFF0C\u8BF7\u4F7F\u7528\u6211\u4EEC\u7684\u201C\u5E2E\u52A9\u201D\u529F\u80FD\u6216\u201C\u8054\u7CFB\u6211\u4EEC\u201D\u94FE\u63A5\u5BFB\u6C42\u5E2E\u52A9\uFF0C\u4EE5\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002",
  ERROR_UPLOADING_FILE: "\u672A\u6DFB\u52A0\u6587\u4EF6",
  ESTIMATED_BASIC_DATE: "\u9884\u4F30\u57FA\u672C\u4FDD\u4FEE\u7ED3\u675F\u65E5\u671F",
  ESTIMATED_BASIC_DAYS: "\u9884\u4F30\u57FA\u672C\u4FDD\u4FEE\u603B\u5929\u6570",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "\u672A\u62A5\u544A\u7684\u6F14\u793A\u72B6\u6001\u548C\u5C0F\u65F6\u6570\u4E0D\u80FD\u53CD\u6620\u5728\u5728\u9884\u4F30\u7ED3\u679C\u4E2D",
  EXCEEDS_DEMO_THRESHOLD: "\u8D85\u51FA\u6F14\u793A\u9608\u503C",
  EXCHANGE_RATE: "\u6C47\u7387",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "\u6B64\u62A5\u544A\u4E2D\u4E0D\u5305\u542B\u6392\u9664\u7684PIN\u3002",
  EXECUTE: "\u6267\u884C",
  EXPAND_ALL: "\u5168\u90E8\u5C55\u5F00",
  EXPECTED_FIRST_USE: "\u9884\u8BA1\u7684\u9996\u6B21\u4F7F\u7528\u65E5\u671F",
  EXPIRATION_DATE: "\u5230\u671F\u65E5\u671F",
  EXPIRED: "\u5DF2\u8FC7\u671F",
  EXPIRED_PART_REQUESTS: "\u8FC7\u671F\u7684\u96F6\u4EF6\u8BF7\u6C42",
  EXPIRED_PIPS: "\u5230\u671F PIP",
  EXPIRES: "\u5230\u671F\u65E5\u671F",
  EXPIRING_SOON: "\u5373\u5C06\u5230\u671F",
  EXPORT: "\u5BFC\u51FA",
  EXTENDED_WARRANTY: "\u5EF6\u957F\u4FDD\u4FEE",
  FACTORY: "\u5DE5\u5382",
  FACTORY_NAME: "\u5DE5\u5382\u540D\u79F0",
  FAILED: "\u6545\u969C\u65E5\u671F",
  FAILED_AREA: "\u6545\u969C\u90E8\u4F4D",
  FAILED_AREA_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6545\u969C\u90E8\u4F4D",
  FAILED_DATE: "\u6545\u969C\u65E5\u671F",
  FAILED_DATE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6545\u969C\u65E5\u671F",
  FAILED_MODE: "\u6545\u969C\u7C7B\u578B",
  FAILED_MODE_COMMENTS: "\u6545\u969C\u7C7B\u578B\u6CE8\u91CA",
  FAILED_PART: "\u6545\u969C\u90E8\u4EF6",
  FAILED_PART_DESCRIPTION: "\u6545\u969C\u90E8\u4EF6\u8BF4\u660E",
  FAILED_PART_IS_A_REMAN_PART: "\u5931\u8D25\u7684\u90E8\u5206\u662FReMan\u90E8\u5206",
  FAILED_PART_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6545\u969C\u90E8\u4EF6",
  FAILED_PART_SERIAL: "\u6545\u969C\u90E8\u4EF6\u5E8F\u5217",
  FAILED_PART_SERIAL_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6545\u969C\u90E8\u4EF6\u5E8F\u53F7",
  FAILURE_DATE: "\u6545\u969C\u65E5\u671F",
  FAILURE_INFORMATION: "\u6545\u969C\u4FE1\u606F",
  FAILURE_MODE: "\u6545\u969C\u7C7B\u578B",
  FAILURE_MODE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6545\u969C\u7C7B\u578B",
  FAILURE_PART: "\u6545\u969C\u90E8\u4EF6",
  FAILURE_PART_DESCRIPTION: "\u6545\u969C\u96F6\u4EF6\u8BF4\u660E",
  FAILURE_PART_IS_REQUIRED: "\u6545\u969C\u96F6\u4EF6\u5FC5\u9700",
  FAILURE_TO_RETURN_PARTS_WARNING: "\u672A\u80FD\u9000\u56DE\u6240\u8BF7\u6C42\u7684\u90E8\u5206\u53EF\u80FD\u5BFC\u81F4\u501F\u8BB0\u3002",
  FAVORITES: "\u6536\u85CF\u5939",
  FILE_NAME: "\u6587\u4EF6\u540D",
  FILE_SIZE_IS_TOO_BIG: "\u6587\u4EF6\u592A\u5927\uFF08\u6700\u5927\u5BB9\u91CF\uFF1A100 MB\uFF09",
  FILE_SIZE_IS_TOO_BIG_CSV: "\u6587\u4EF6\u592A\u5927\uFF08\u6700\u5927\u5BB9\u91CF\uFF1A1 MB\uFF09",
  FILE_UPLOAD_MESSAGE: "\u5C06\u6587\u4EF6\u62D6\u653E\u5230\u6B64\u5904\u6216\u8005\u5355\u51FB\u6B64\u5904\u4EE5\u6DFB\u52A0\u6587\u4EF6\uFF08\u6700\u5927\u5BB9\u91CF\uFF1A 100 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "\u5C06\u6587\u4EF6\u62D6\u653E\u5230\u6B64\u5904\u6216\u8005\u5355\u51FB\u6B64\u5904\u4EE5\u6DFB\u52A0\u6587\u4EF6\uFF08\u6700\u5927\u5BB9\u91CF\uFF1A 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "\u5728\u6B64\u5904\u62D6\u653E\u56FE\u50CF\u6216\u5355\u51FB\u6B64\u5904\u6DFB\u52A0\u56FE\u50CF\uFF08\u6700\u5927\u5BB9\u91CF\uFF1A100 MB)",
  FILE_UPLOAD_MESSAGE_SINGLE: "\u5C06\u5355\u4E2A\u6587\u4EF6\u62D6\u653E\u5230\u6B64\u5904\u6216\u5355\u51FB\u4EE5\u6DFB\u52A0\uFF08\u6700\u5927\u6587\u4EF6\u5C3A\u5BF8\uFF1A100 MB\uFF09",
  FILE_UPLOAD_UNABLE_TO_READ: "\u7CFB\u7EDF\u65E0\u6CD5\u8BFB\u53D6\u60A8\u7684\u6587\u4EF6\u3002  \u8BF7\u5C06\u5176\u4E0E\u6A21\u677F\u8FDB\u884C\u6BD4\u8F83\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
  FILES: "\u6587\u4EF6",
  FILTER_PLACEHOLDER: "\u7B5B\u9009\u7ED3\u679C",
  FILTER_WITH_ELLIPSIS: "\u7B5B\u9009\u2026\u2026",
  FILTERED_BY_COLUMN_ID: "\u6309 {columnId} \u5220\u9009",
  FIND_CUSTOMER: "\u67E5\u627E\u5BA2\u6237",
  FINNISH: "\u82AC\u5170\u8BED",
  FIRST_MAINTENANCE: "\u9996\u6B21\u7EF4\u62A4",
  FIRST_NAME: "\u540D",
  FIRST_NAME_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u540D\u5B57",
  FIRST_SHIP_TO_LOCATION: "\u7B2C\u4E00\u6536\u8D27\u5730\u5740",
  FIRST_USE: "\u9996\u6B21\u4F7F\u7528",
  FISCAL_YEAR: "\u8D22\u5E74",
  FLUID_SAMPLING_REQUIRED: "\u6D41\u4F53\u53D6\u6837\u5FC5\u9700",
  FORWARDED: "\u8F6C\u53D1",
  FRENCH: "\u6CD5\u8BED",
  FRWRD: "\u8F6C\u53D1",
  FULL_DEBIT: "\u5168\u90E8\u6263\u6B3E",
  GENERAL: "\u5E38\u89C4",
  GERMAN: "\u5FB7\u8BED",
  GET_MAINTENANCE_PLANS: "\u83B7\u53D6\u7EF4\u62A4\u8BA1\u5212",
  GOODS_INSTALLATION_VAT: "\u8D27\u7269\u5B89\u88C5 VAT",
  GRACE_PERIOD: "\u5BBD\u9650\u671F",
  GREATER_THAN: "\u5927\u4E8E",
  GREATER_THAN_OR_EQUALS: "\u5927\u4E8E\u7B49\u4E8E",
  GROUP_COMPLETE: "\u7ECF\u9500\u5546\u603B\u5B8C\u6210\u7387",
  GST_PERCENTAGE: "GST \u767E\u5206\u6BD4",
  HISTORY_TO_DISPLAY: "\u8981\u663E\u793A\u7684\u5386\u53F2\u8BB0\u5F55\uFF08\u5929\u6570\uFF09",
  HOME: "\u4E3B\u9875",
  HOUR_LIMIT: "\u5C0F\u65F6\u6570\u9650\u5236",
  HOURS: "\u5C0F\u65F6\u6570",
  HOURS_ON_RENT: "\u79DF\u8D41\u5C0F\u65F6\u6570",
  HSN_SAC_CODE: "HSN/SAC \u4EE3\u7801",
  IGST: "IGST",
  IMPLEMENTS: "\u519C\u5177",
  IN_RANGE: "\u533A\u95F4",
  INCENTIVE: "\u6FC0\u52B1",
  INCENTIVE_PROGRAMS: "\u6FC0\u52B1\u8BA1\u5212",
  INCLUDE_FULLY_COMPLETE: "\u5305\u62EC\u5DF2\u5B8C\u6210\u7684PIP",
  INDICATES_REQUIRED_FIELD: "\u8868\u793A\u5FC5\u586B\u5B57\u6BB5",
  INFO_MESSAGE_TITLE: "\u5DF2\u53D1\u9001\u4E00\u4E2A\u7CFB\u7EDF\u901A\u77E5\uFF1A",
  INFO_MESSAGES: "\u4FE1\u606F\u6027\u6D88\u606F",
  INFO_MESSAGES_TITLE: "\u5DF2\u53D1\u9001\u591A\u4E2A\u7CFB\u7EDF\u901A\u77E5\uFF1A",
  INFO_REQUEST_STATUS_ERROR: "\u4FE1\u606F\u968F\u65F6\u53EF\u4EE5\u4E0E\u6B64\u8BF7\u6C42\u4E00\u8D77\u63D0\u4EA4\u3002",
  INFORMATION: "\u4FE1\u606F",
  INFORMATION_REQUEST: "\u4FE1\u606F\u8BF7\u6C42",
  INFORMATION_REQUEST_STATUS: "\u4FE1\u606F\u8BF7\u6C42\u72B6\u6001",
  INPUT_PIN: "\u8F93\u5165 PIN",
  INSPECTION: "\u68C0\u67E5",
  INSTALLED_BY: "\u5B89\u88C5\u4EBA",
  INSTALLED_BY_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5B89\u88C5\u4EBA",
  INTERNAL_DEERE_COMMENTS: "\u5185\u90E8 Deere \u5907\u6CE8",
  INTERVAL_BEGINS: "\u95F4\u9694\u5F00\u59CB",
  INTERVAL_ENDS: "\u95F4\u9694\u7ED3\u675F",
  INTERVAL_TYPE_DESCRIPTION: "\u95F4\u9694\u7C7B\u578B\u8BF4\u660E",
  INVOICE_ACCOUNT: "\u53D1\u7968\u8D26\u6237",
  INVOICE_DEALER: "\u53D1\u7968\u7ECF\u9500\u5546",
  INVOICE_NUMBER: "\u53D1\u7968\u53F7",
  INVOICE_REQUEST: "\u53D1\u7968\u9700\u6C42\u8868",
  INVOICE_SENT: "\u53D1\u7968\u5BC4\u9001\u65E5\u671F",
  INVOICE_UPDATED_SUCCESSFULLY: "\u53D1\u7968\u5DF2\u6210\u529F\u66F4\u65B0",
  INVOICED: "\u53D1\u7968\u65E5\u671F",
  INVOICED_TO: "\u5F00\u7968\u5BF9\u8C61",
  IRC_PIN_MESSAGE: "\u5BA2\u6237\u662FIRC\uFF0C\u6709\u6743\u5728\u673A\u5668\u62E5\u6709\u540E\u7684\u7B2C\u4E00\u4E2A500\u5C0F\u65F6\u621612\u4E2A\u6708\u5185\u4EAB\u53D7\u514D\u8D39\u5DEE\u65C5\u65F6\u95F4\u548C\u91CC\u7A0B\u3002",
  ISSUED: "\u53D1\u5E03\u65E5\u671F",
  ITALIAN: "\u610F\u5927\u5229\u8BED",
  ITEM: "\u8BA2\u5355\u9879",
  ITEM_NUMBER: "\u9644\u4EF6\u7F16\u53F7",
  ITEM_NUMBER_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u9644\u4EF6\u7F16\u53F7",
  JDLINK_EXPIRES: "JDLink \u5931\u6548",
  JDP_COMMENTS: "JDP \u5907\u6CE8",
  JDP_COMMENTS_IS_REQUIRED: "\u9700\u8981\u586B\u5199 JDP \u5907\u6CE8",
  JDP_CUSTOMER_RESOLUTION: "JDP \u5BA2\u6237\u89E3\u51B3\u65B9\u6848",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "\u9700\u8981\u586B\u5199 JDP \u5BA2\u6237\u89E3\u51B3\u65B9\u6848",
  JDP_REASON: "JDP \u539F\u56E0",
  JDP_REASON_IS_REQUIRED: "\u9700\u8981\u586B\u5199 JDP \u539F\u56E0",
  LABOR: "\u4EBA\u5DE5",
  LABOR_ADDITIVE: "\u4EBA\u5DE5\u8865\u8D34",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "\u4EBA\u5DE5\u8865\u8D34\u5B8C\u6210\u7387\u8BE6\u60C5",
  LABOR_ADDITIVE_PIPS: "\u4EBA\u5DE5\u8865\u8D34 PIP",
  LABOR_ADDITIVE_TAB: "\u4EBA\u5DE5\u8865\u8D34 ({count})",
  LABOR_ADJUSTMENT: "\u4EBA\u5DE5\u8C03\u6574",
  LABOR_COMMENTS: "\u4EBA\u5DE5 \u5907\u6CE8",
  LABOR_HOURS: "\u4EBA\u5DE5 \u5C0F\u65F6\u6570",
  LABOR_ITEM_DETAILS: "\u4EBA\u5DE5 - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "\u4EBA\u5DE5\u8D39\u7387\u5DF2\u6210\u529F\u6279\u51C6",
  LABOR_RATE_CHANGE_SUBMITTED: "\u4EBA\u5DE5\u8D39\u7387\u66F4\u6539\u5DF2\u63D0\u4EA4",
  LABOR_RATE_CHANGES_WITH_COUNT: "\u4EBA\u5DE5\u8D39\u7387\u66F4\u6539 ({count})",
  LABOR_RATE_CONFIRM: "\u8BF7\u6C42\u8D39\u7387\u4F4E\u4E8E\u5F53\u524D\u8D39\u7387\u3002\u786E\u8BA4\u8981\u63D0\u4EA4\u8BE5\u8BF7\u6C42\u5417\uFF1F",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "\u7EA2\u8272\u6587\u672C\u4E2D\u7684\u65BD\u91CF\u8868\u793A\u6BD4\u73B0\u6709\u65BD\u91CF\u589E\u52A010%\u4EE5\u4E0A",
  LABOR_RATE_HISTORY: "\u5DE5\u65F6\u8D39\u7387\u5386\u53F2\u8BB0\u5F55",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "\u4EBA\u5DE5\u8D39\u7387\u5DF2\u6210\u529F\u62D2\u7EDD",
  LABOR_RATE_REQUESTS_STATUS: "\u4EBA\u5DE5\u8D39\u7387\u8BF7\u6C42\u72B6\u6001",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "\u4EBA\u5DE5\u8D39\u7387\u5DF2\u6210\u529F\u9000\u56DE",
  LABOR_RATES: "\u4EBA\u5DE5\u8D39\u7387",
  LABOR_STATS: "\u5DE5\u65F6\u7EDF\u8BA1",
  LABOR_TOTAL: "\u4EBA\u5DE5\u5408\u8BA1",
  LABOR_TYPE: "\u4EBA\u5DE5\u7C7B\u578B",
  LABOR_VALUE: "\u4EBA\u5DE5\u503C",
  LABOR_WITH_COUNT: "\u4EBA\u5DE5 ({count})",
  LANGUAGE: "\u8BED\u8A00",
  LAST_LOCATION_FROM: "\u6700\u540E\u4F4D\u7F6E",
  LAST_NAME: "\u59D3\u6C0F",
  LAST_NAME_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u59D3",
  LAST_PERSONAL_CONTACT: "\u6700\u540E\u4E00\u6B21\u8054\u7CFB",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "\u6267\u6CD5\u673A\u6784\u8BE6\u7EC6\u4FE1\u606F",
  LAYOUT_CREATED_SUCCESSFULLY: "\u7248\u9762\u5DF2\u6210\u529F\u521B\u5EFA",
  LAYOUT_DELETED_SUCCESSFULLY: "\u5E03\u5C40\u5DF2\u6210\u529F\u5220\u9664",
  LAYOUT_NAME: "\u5E03\u5C40\u540D\u79F0",
  LAYOUT_UPDATED_SUCCESSFULLY: "\u5E03\u5C40\u5DF2\u6210\u529F\u66F4\u65B0",
  LEAD_ACCOUNT: "\u603B\u5E10\u6237",
  LEAD_DEALER: "\u603B\u7ECF\u9500\u5546",
  LESS_THAN: "\u5C0F\u4E8E",
  LESS_THAN_OR_EQUALS: "\u5C0F\u4E8E\u7B49\u4E8E",
  LICENSE_PLATE_NUMBER: "\u724C\u7167\u53F7",
  LIFETIME: "\u7EC8\u751F",
  LINE_ITEMS_EXPORT: "\u884C\u9879\u76EE\u5BFC\u51FA",
  LIST: "\u6E05\u5355",
  LIST_TOTAL: "\u6E05\u5355\u603B\u8BA1",
  LOCATION: "\u5730\u70B9",
  LOCATION_DUE: "\u4F4D\u7F6E\u5230\u671F",
  LOCATIONS: "\u5730\u70B9",
  LOCATIONS_WITH_COUNT: "\u5730\u70B9 ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "\u673A\u5668\u5DF2\u6CE8\u518C\u5230\u6B64\u5BA2\u6237",
  MACHINE_INFORMATION: "\u673A\u5668\u4FE1\u606F",
  MACHINE_MODEL_TYPE: "\u673A\u5668\u578B\u53F7/\u7C7B\u578B",
  MACHINE_MODEL_TYPE_REQUIRED: "\u673A\u5668\u578B\u53F7/\u578B\u5F0F\u5FC5\u586B",
  MACHINE_STATUS: "\u673A\u5668\u72B6\u6001",
  MACHINE_STATUS_UPDATE_ACCEPTED: "\u673A\u5668\u72B6\u6001\u66F4\u65B0\u5DF2\u6279\u51C6",
  MACHINE_STATUS_UPDATE_DOCUMENT: "\u673A\u5668\u72B6\u6001\u66F4\u65B0\u6587\u6863",
  MACHINE_STATUS_UPDATE_REJECTED: "\u673A\u5668\u72B6\u6001\u66F4\u65B0\u5DF2\u62D2\u7EDD",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "\u673A\u5668\u72B6\u6001\u66F4\u65B0 ({count})",
  MACHINE_TYPE: "\u673A\u5668\u7C7B\u578B",
  MACHINE_TYPE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u673A\u5668\u7C7B\u578B",
  MACHINE_USE: "\u673A\u5668\u4F7F\u7528\u91CF",
  MAILING_RECIPIENT: "\u90AE\u5BC4\u6536\u4EF6\u4EBA\uFF08\u540D\u5B57\u548C\u59D3\u6C0F\uFF09",
  MAILING_RECIPIENT_REQUIRED: "\u9700\u8981\u90AE\u5BC4\u6536\u4EF6\u4EBA",
  MAINTENANCE: "\u7EF4\u62A4",
  MAINTENANCE_PLAN: "\u7EF4\u62A4\u8BA1\u5212",
  MAINTENANCE_PLAN_INFO: "\u7EF4\u62A4\u8BA1\u5212\u4FE1\u606F",
  MARK_AS_REVIEW: "\u6807\u8BB0\u4E3A\u5DF2\u5BA1\u9605",
  MARKETING_INCENTIVE: "\u5E02\u573A\u8425\u9500 - \u6FC0\u52B1",
  MARKETING_JD_PROMISE: "\u5E02\u573A\u8425\u9500 - JD Promise",
  MARKETING_MAINTENANCE_PLAN: "\u5E02\u573A\u8425\u9500 - \u7EF4\u62A4\u8BA1\u5212",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "\u5E02\u573A\u8425\u9500 - \u6279\u91CF\u6E20\u9053\u8DDF\u8FDB",
  MARKETING_MASS_CHANNEL_PDI: "\u5E02\u573A\u8425\u9500 - \u6279\u91CF\u6E20\u9053 PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "\u6279\u91CF\u6E20\u9053\u5BA2\u6237\u8DDF\u8FDB",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "\u5728\u6B64\u63D0\u9192\uFF0C\u8BF7\u786E\u4FDD\u60A8\u5728\u5B9E\u65BD\u552E\u540E\u7535\u8BDD\u8DDF\u8FDB\u8BA1\u5212\u4E4B\u524D\u5DF2\u8054\u7CFB\u5F53\u5730\u6CD5\u5F8B\u987E\u95EE\u786E\u8BA4\u53EF\u4EE5\u81F4\u7535\u5BA2\u6237\u3002",
  MASS_CHANNEL_PDI_CLAIM: "\u6279\u91CF\u6E20\u9053 PDI",
  MASTER_WARRANTY_TYPE: "\u4E3B\u4FDD\u4FEE\u7C7B\u578B",
  MATERIAL: "\u7269\u6599\u7F16\u53F7",
  MERCHANDISE: "\u5546\u54C1",
  MESSAGE: "\u63D0\u793A\u4FE1\u606F",
  MESSAGES: "\u6D88\u606F",
  METHOD_OF_CONTACT: "\u8054\u7CFB\u65B9\u6CD5",
  METHOD_OF_CONTACT_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u8054\u7CFB\u65B9\u6CD5",
  METRIC: "\u6307\u6807",
  METRICS: "\u6307\u6807",
  MILEAGE_LIMIT: "\u91CC\u7A0B\u9650\u5236",
  MOBILE_PHONE: "\u79FB\u52A8\u7535\u8BDD",
  MODEL: "\u578B\u53F7",
  MODEL_NUMBER: "\u578B\u53F7",
  MODIFIED: "\u4FEE\u6539\u65E5\u671F",
  MONTH_TO_DATE: "\u672C\u6708\u81F3\u4ECA",
  MORE: "\u66F4\u591A",
  MULTIPLE: "\u591A\u91CD",
  NAME: "\u540D\u79F0",
  NET: "\u51C0\u503C",
  NET_AMOUNT: "\u51C0\u503C",
  NET_AMOUNT_PAID: "\u51C0\u8D54\u4ED8\u503C",
  NET_TOTAL: "\u51C0\u603B\u503C",
  NEW: "\u65B0",
  NEW_ACCOUNT: "\u65B0\u5EFA\u5E10\u6237",
  NEW_CLAIM: "\u65B0\u7D22\u8D54",
  NEW_CLAIM_VALUE: "\u65B0\u7D22\u8D54\u503C",
  NEW_CUSTOMER_REQUIRED: "\u65B0\u5BA2\u6237\u5FC5\u586B",
  NEW_DEALER: "\u65B0\u7ECF\u9500\u5546",
  NEW_DEALER_DISTANCE: "\u65B0\u7ECF\u9500\u5546\u8DDD\u79BB",
  NEW_DEALER_LOCATION: "\u65B0\u7ECF\u9500\u5546\u5730\u70B9",
  NEW_LABOR_RATE: "\u65B0\u4EBA\u5DE5\u8D39\u7387",
  NEW_REQUEST_ENTER_RATES: "\u65B0\u8BF7\u6C42 \u2014 \u8F93\u5165\u65BD\u91CF",
  NEW_STATUS: "\u65B0\u72B6\u6001",
  NEW_TRANSFER: "\u65B0\u79FB\u4EA4",
  NEW_TRANSFER_CREATED: "\u5DF2\u521B\u5EFA\u65B0\u79FB\u4EA4",
  NEW_VALUE: "\u65B0\u503C",
  NO: "\u5426",
  NO_ACTIVE_WARRANTY: "\u65E0\u6709\u6548\u4FDD\u4FEE",
  NO_AFFECTED_PINS: "\u5728\u60A8\u7684\u8D23\u4EFB\u8303\u56F4\u5185\uFF0C\u65E0\u53D7\u5F71\u54CD\u7684 \u4EA7\u54C1",
  NO_AUTHORITY_TO_ACCESS: "\u60A8\u65E0\u6743\u8BBF\u95EEJDWS\u3002\u7ECF\u9500\u5546\u7528\u6237\u8BF7\u8DDF\u8FDB\u60A8\u7684\u914D\u7F6E\u6587\u4EF6\u7BA1\u7406\u5458(DPA)\u4EE5\u9A8C\u8BC1\u6743\u9650\uFF0C\u6234\u5C14\u7528\u6237\u5728\u6B64\u5904\u4E0E\u652F\u6301\u90E8\u95E8\u8054\u7CFB\uFF0C\u5E76\u63D0\u4F9B\u6B64\u9519\u8BEF\u7684\u526F\u672C",
  NO_CLAIMS: "\u65E0\u7D22\u8D54\u3002",
  NO_CUSTOMER_ASSOCIATED: "\u65E0\u76F8\u5173\u8054\u7684\u5BA2\u6237",
  NO_CUSTOMER_SELECTED: "\u672A\u9009\u62E9\u5BA2\u6237",
  NO_DEALER_INVOICES: "\u65E0\u7ECF\u9500\u5546\u53D1\u7968",
  NO_DEALERS_MAPPED: "\u8FD8\u672A\u6709\u7ECF\u9500\u5546\u548C\u60A8\u7684\u7528\u6237\u540D\u76F8\u5173\u8054\u3002 \u8BF7\u4E0E\u7CFB\u7EDF\u7BA1\u7406\u5458\u8054\u7CFB\u3002",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "\u4E0D\u80FD\uFF08\u5982\u679C\u4E0D\u80FD\uFF0C\u5FC5\u987B\u63D0\u4F9B\u7167\u7247\u4F5C\u4E3A\u8BC1\u636E\uFF09",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "\u6CA1\u6709\u8BE5\u4EA7\u54C1\u7684\u4FE1\u606F\u3002",
  NO_LOWERCASE: "\u65E0",
  NO_MATCHING_DEALERS: "\u6CA1\u6709\u7ECF\u9500\u5546\u7B26\u5408\u7B5B\u9009\u6761\u4EF6\u3002",
  NO_OPEN_PART_REQUESTS: "\u6CA1\u6709\u516C\u5F00\u90E8\u4EF6\u8BF7\u6C42",
  NO_OPEN_PIPS: "\u65E0\u672A\u7ED3 PIP",
  NO_PARTS_RETURNED: "\u6CA1\u6709\u8FD4\u56DE\u96F6\u4EF6",
  NO_PIP_PRODUCTS: "\u6CA1\u6709\u6B64\u7C7B PIP \u4EA7\u54C1\u3002",
  NO_PRODUCT_FOUND: "\u672A\u627E\u5230\u4EA7\u54C1",
  NO_REQUIRED_ITEMS: "\u65E0\u5FC5\u9700\u9879\u76EE\u3002",
  NO_RESULTS: "\u65E0\u7ED3\u679C",
  NO_RESULTS_FOUND: "\u672A\u627E\u5230\u7ED3\u679C",
  NO_ROWS_TO_SHOW: "\u65E0\u7ED3\u679C\u53EF\u663E\u793A",
  NO_SPECIAL_INSTRUCTIONS: "\u65E0\u7279\u6B8A\u8BF4\u660E\u3002",
  NO_TRAVEL: "\u65E0\u5DEE\u65C5",
  NON_RECOVERABLE_TAXES: "\u4E0D\u53EF\u62B5\u6263\u7A0E",
  NON_TRACKED_PINS_HELP_TEXT: "\u6709\u4E9B\u4EA7\u54C1\u53EA\u6709\u6CE8\u518C\u540E\u624D\u4F1A\u51FA\u73B0\u5728\u4FDD\u4FEE\u7CFB\u7EDF\u5185\u3002\u60A8\u7684\u641C\u7D22\u548C\u6B64\u7C7B\u4EA7\u54C1\u76F8\u5339\u914D\u3002",
  NON_TRAVEL: "\u975E\u5DEE\u65C5",
  NONE: "\u65E0",
  NORMAL: "\u6B63\u5E38",
  NOT_EQUAL: "\u4E0D\u7B49\u4E8E",
  NOTIFICATION_ADDED_SUCCESSFULLY: "\u901A\u77E5\u5DF2\u6210\u529F\u6DFB\u52A0",
  NOTIFICATION_DELETED_SUCCESSFULLY: "\u901A\u77E5\u5DF2\u6210\u529F\u5220\u9664",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "\u901A\u77E5\u987A\u5E8F\u5DF2\u6210\u529F\u66F4\u65B0",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "\u901A\u77E5\u5DF2\u6210\u529F\u66F4\u65B0",
  NOTIFICATIONS: "\u901A\u77E5",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "\u8BCA\u65AD\u53D1\u751F\u6B21\u6570",
  NUMBER_OF_OPEN_PIPS: "{number} \u672A\u7ED3 PIP",
  NUMBER_OF_REPAIR_OCCURRENCES: "\u7EF4\u4FEE\u53D1\u751F\u6B21\u6570",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "\u66F4\u6362\u53D1\u751F\u6B21\u6570",
  OLD_LABOR_RATE: "\u4EE5\u524D\u7684\u4EBA\u5DE5\u8D39\u7387",
  ON_SHELF: "\u4E0A\u67B6",
  ON_SHELF_COST: "\u4E0A\u67B6\u6210\u672C",
  ONE_ITEM_MUST_BE_SELECTED: "\u5FC5\u987B\u9009\u62E9\u4E00\u4E2A\u9879\u76EE",
  OPEN: "\u672A\u7ED3",
  OPEN_PART_REQUESTS: "\u672A\u5904\u7406\u96F6\u4EF6\u8BF7\u6C42",
  OPEN_PART_REQUESTS_WITH_COUNT: "\u672A\u5904\u7406\u96F6\u4EF6\u8BF7\u6C42 ({count})",
  OPEN_PIP_COUNT: "\u6253\u5F00PIP\u8BA1\u6570",
  OPEN_PIP_PROGRAMS: "PIP \u767B\u8BB0",
  OPEN_PIPS: "\u672A\u7ED3 PIP",
  OPEN_PIPS_REPORT: "\u672A\u5B8C\u6210PIP\u62A5\u544A",
  OPEN_PIPS_TAB: "\u672A\u7ED3 PIP ({count})",
  OPERATORS_COMPLAINT: "\u64CD\u4F5C\u5458\u62B1\u6028\u4E86\u4EC0\u4E48\u95EE\u9898\uFF1F",
  OPERATORS_COMPLAINT_IS_REQUIRED: "\u5FC5\u9700\u586B\u5199\u64CD\u4F5C\u5458\u62B1\u6028\u7684\u95EE\u9898",
  OPERATORS_MANUAL_NUMBER: "\u64CD\u4F5C\u624B\u518C\u53F7",
  OPTION_CODE: "\u9009\u914D\u4EE3\u7801",
  OPTION_CODE_CREATED_SUCCESSFULLY: "\u9009\u914D\u4EE3\u7801\u521B\u5EFA\u6210\u529F",
  OPTION_CODE_DELETED_SUCCESSFULLY: "\u9009\u914D\u4EE3\u7801\u5220\u9664\u6210\u529F",
  OPTION_CODES: "\u9009\u914D\u4EE3\u7801",
  OR: "\u6216",
  ORIGINAL_CLAIM_VALUE: "\u539F\u59CB\u7D22\u8D54\u503C",
  ORIGINAL_SUBMISSION_DATE: "\u9996\u6B21\u63D0\u4EA4\u65E5\u671F",
  ORIGINALLY_SUBMITTED: "\u9996\u6B21\u63D0\u4EA4\u65E5\u671F",
  OTHER: "\u5176\u4ED6",
  OTHER_AMOUNT_OF_USE: "\u5176\u4ED6\u4F7F\u7528\u91CF",
  OTHER_AMOUNT_OF_USE_REQUIRED: "\u5176\u4ED6\u4F7F\u7528\u91CF\u5FC5\u586B",
  OTHER_CREDIT: "\u5176\u4ED6\u8D54\u4ED8",
  OTHER_CREDIT_1: "\u5176\u4ED6\u8D54\u4ED8 1",
  OTHER_CREDIT_2: "\u5176\u4ED6\u8D54\u4ED8 2",
  OTHER_CREDIT_3: "\u5176\u4ED6\u8D54\u4ED8 3",
  OTHER_CREDIT_ADJUSTMENT: "\u5176\u4ED6\u8D37\u9879\u8C03\u6574",
  OTHER_CREDIT_ITEM_DETAILS: "\u5176\u4ED6\u8D54\u4ED8 - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "\u5176\u4ED6\u8D54\u4ED8\u603B\u8BA1",
  OTHER_CREDITS: "\u5176\u4ED6\u8D54\u4ED8",
  OTHER_CREDITS_WITH_COUNT: "\u5176\u4ED6\u8D54\u4ED8 ({count})",
  OTHER_INSTRUCTIONS: "\u5176\u4ED6\u8BF4\u660E",
  OUTPUT_PIN: "\u8F93\u51FA PIN",
  OVERDUE: "\u8FC7\u671F",
  OVERRIDE_ACCOUNT: "\u8986\u76D6\u5E10\u6237",
  OVERRIDE_EFFECTIVE_DATE: "\u66FF\u4EE3\u751F\u6548\u65E5\u671F",
  OVERRIDE_SUGGESTED_ACCOUNT: "\u8D85\u63A7\u5EFA\u8BAE\u7684\u5E10\u6237",
  OWNERSHIP_STATUS: "\u6240\u6709\u6743\u72B6\u6001",
  OWNERSHIP_STATUS_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u6240\u6709\u6743\u72B6\u6001",
  PART: "\u96F6\u4EF6",
  PART_1: "\u96F6\u4EF6 1",
  PART_2: "\u96F6\u4EF6 2",
  PART_3: "\u96F6\u4EF6 3",
  PART_4: "\u96F6\u4EF6 4",
  PART_5: "\u96F6\u4EF6 5",
  PART_6: "\u96F6\u4EF6 6",
  PART_7: "\u96F6\u4EF6 7",
  PART_8: "\u96F6\u4EF6 8",
  PART_9: "\u96F6\u4EF6 9",
  PART_10: "\u96F6\u4EF6 10",
  PART_AMONT_OF_USE: "\u96F6\u4EF6\u4F7F\u7528\u65F6\u95F4",
  PART_FAMILY: "\u96F6\u4EF6\u6240\u5C5E\u4EA7\u54C1\u7CFB\u5217",
  PART_ITEM_DETAILS: "\u96F6\u4EF6 - {quantity} {description} \u96F6\u4EF6\u7F16\u53F7 {partNumber}",
  PART_NUMBER: "\u96F6\u4EF6\u53F7",
  PART_REQUEST: "\u96F6\u4EF6\u8BF7\u6C42",
  PART_REQUEST_NUMBER: "\u96F6\u4EF6\u8BF7\u6C42 {rgaNumber}",
  PART_REQUEST_STATUS: "\u96F6\u4EF6\u8BF7\u6C42\u72B6\u6001",
  PART_REQUESTS: "\u96F6\u4EF6\u8BF7\u6C42",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "\u8F93\u5165\u7D22\u8D54\u53F7\uFF0C\u6700\u5C11 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "\u7D22\u8D54\u641C\u7D22\u5FC5\u987B\u81F3\u5C11\u4E3A 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "DTAC \u6848\u4F8B\u7F16\u53F7\u641C\u7D22\u5FC5\u987B\u4E3A\u5B8C\u6574\u7684 DTAC \u6848\u4F8B\u7F16\u53F7\uFF0C\u957F\u5EA6\u81F3\u5C11\u4E3A 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "\u8F93\u5165\u5B8C\u6574\u7684 DTAC \u6848\u4F8B\u7F16\u53F7",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "\u96F6\u4EF6\u53F7\u641C\u7D22\u5FC5\u987B\u81F3\u5C11\u4E3A 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "\u8F93\u5165\u96F6\u4EF6\u53F7\uFF0C\u6700\u5C11 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "\u96F6\u4EF6\u8BF7\u6C42\u7F16\u53F7\u641C\u7D22\u5FC5\u987B\u81F3\u5C11\u4E3A 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "\u8F93\u5165\u96F6\u4EF6\u8BF7\u6C42\u7F16\u53F7\uFF0C\u6700\u5C11 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "PIN \u641C\u7D22\u5FC5\u987B\u81F3\u5C11\u4E3A 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "\u8F93\u5165 PIN\uFF0C\u6700\u5C11 4 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "\u5DE5\u5355\u641C\u7D22\u5FC5\u987B\u4E3A\u5B8C\u6574\u7684\u5DE5\u5355\u53F7\uFF0C\u81F3\u5C11\u4E3A 2 \u4E2A\u5B57\u7B26",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "\u8F93\u5165\u5B8C\u6574\u5DE5\u5355\u53F7",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "\u96F6\u4EF6\u8BF7\u6C42\u66F4\u65B0\u6210\u529F",
  PART_RETURN: "\u96F6\u4EF6\u8FD4\u56DE",
  PART_RETURNS: "\u96F6\u4EF6\u8FD4\u56DE",
  PART_SERIAL_NUMBER: "\u96F6\u4EF6\u5E8F\u5217\u53F7",
  PART_SERIAL_NUMBER_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u96F6\u4EF6\u5E8F\u5217\u53F7",
  PART_TOTAL: "\u96F6\u4EF6\u603B\u8BA1",
  PART_TYPE: "\u96F6\u4EF6\u7C7B\u578B",
  PART_USE: "\u96F6\u4EF6\u4F7F\u7528\u65F6\u95F4",
  PART_VALUE: "\u96F6\u4EF6\u503C",
  PARTIAL_DEBIT: "\u90E8\u5206\u6263\u6B3E",
  PARTICIPANT: "\u53C2\u4E0E\u8005",
  PARTS: "\u96F6\u4EF6",
  PARTS_ADDITIVE: "\u96F6\u4EF6\u8865\u8D34",
  PARTS_ADJUSTMENT: "\u96F6\u4EF6\u8C03\u6574",
  PARTS_COVERAGE_SEARCH: "\u90E8\u4EF6\u8986\u76D6\u8303\u56F4\u641C\u7D22",
  PARTS_TEMPLATE: "\u96F6\u4EF6\u6A21\u677F",
  PARTS_USE: "\u96F6\u4EF6\u4F7F\u7528\u65F6\u95F4",
  PARTS_USE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u96F6\u4EF6\u4F7F\u7528\u65F6\u95F4",
  PARTS_WITH_COUNT: "\u96F6\u4EF6 ({count})",
  PARTS_WITH_PARENTHESES: "\u96F6\u4EF6",
  PAST_DUE: "\u8FC7\u671F",
  PAYER_ACCOUNT: "\u4ED8\u6B3E\u4EBA\u5E10\u6237",
  PERCENT_COMPLETE: "\u767E\u5206\u6BD4\u5B8C\u6210",
  PERCENTAGE: "\u767E\u5206\u6BD4",
  PERCENTAGE_DEBIT: "\u501F\u8BB0\u767E\u5206\u6BD4",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "\u501F\u8BB0\u767E\u5206\u6BD4",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "\u5BF9\u4E8E\u635F\u574F\u7684\u673A\u5668\uFF0C\u5176\u4FDD\u4FEE\u5C06\u81EA\u52A8\u6682\u505C\uFF0C\u9700\u7B49 TCSM \u5BA1\u6838\u3001\u6279\u51C6\u672C\u8868\u683C\u5B8C\u6BD5\u4E4B\u540E\u65B9\u53EF\u6062\u590D\u4FDD\u4FEE\u3002\u635F\u574F\u7684\u673A\u5668\u4EC5\u6709\u8D44\u683C\u53C2\u52A0\u201C\u5F3A\u5236\u6027 \u6545\u969C\u4E0E\u5B89\u5168\u201D\u4EA7\u54C1\u6539\u8FDB\u8BA1\u5212 (PIP)\u3002",
  PERSON_RESPONSIBLE: "\u8D1F\u8D23\u4EBA",
  PHONE: "\u7535\u8BDD",
  PHONE_REQUIRED: "\u7535\u8BDD\u5FC5\u586B",
  PICTURE: "\u56FE\u7247",
  PICTURE_REQUEST: "\u56FE\u7247\u8BF7\u6C42",
  PICTURE_REQUEST_STATUS: "\u56FE\u7247\u8BF7\u6C42\u72B6\u6001",
  PICTURE_REQUEST_STATUS_ERROR: "\u9644\u4EF6\u968F\u65F6\u53EF\u4EE5\u4E0E\u6B64\u8BF7\u6C42\u4E00\u8D77\u63D0\u4EA4\u3002",
  PIN: "PIN",
  PIN_CREATED_SUCCESSFULLY: "PIN \u5DF2\u6210\u529F\u521B\u5EFA",
  PIN_CROSS_REFERENCE: "\u5E8F\u5217\u53F7\u8F6C\u6362\u67E5\u8BE2",
  PIN_INVALID: "PIN \u65E0\u6548",
  PIN_IS_REQUIRED: "PIN \u5FC5\u9700",
  PIN_REQUIRED: "PIN \u5FC5\u586B",
  PIN_SEARCH: "PIN\u641C\u7D22",
  PIN_SEARCH_INFORMATION: "PIN\u641C\u7D22\u4FE1\u606F",
  PIN_TRANSFER_INFORMATION: "\u63D2\u811A\u8F6C\u79FB\u4FE1\u606F",
  PINS: "PIN",
  PINS_NOT_REGISTERED: "\u672A\u6CE8\u518C\u7684\u4EA7\u54C1",
  PIP: "PIP",
  PIP_CODE: "PIP \u4EE3\u7801",
  PIP_CODE_CREATED_SUCCESSFULLY: "PIP \u4EE3\u7801\u7533\u8BF7\u521B\u5EFA\u6210\u529F",
  PIP_CODE_REQUEST: "PIP \u4EE3\u7801\u7533\u8BF7",
  PIP_CODE_REQUEST_APPROVED: "PIP \u4EE3\u7801\u7533\u8BF7\u5DF2\u6279\u51C6",
  PIP_CODE_REQUEST_REJECTED: "PIP \u4EE3\u7801\u7533\u8BF7\u5DF2\u62D2\u7EDD",
  PIP_CODE_REQUESTS_WITH_COUNT: "PIP \u4EE3\u7801\u7533\u8BF7 ({count})",
  PIP_COMPLETION_STATUS: "PIP \u5B8C\u6210\u72B6\u6001",
  PIP_DETAILS: "PIP \u8BE6\u7EC6\u4FE1\u606F",
  PIP_HISTORY: "PIP \u5386\u53F2\u8BB0\u5F55",
  PIP_ID: "PIP \u7F16\u53F7",
  PIP_NUMBER: "PIP \u53F7",
  PIP_PROGRAM: "PIP \u9879\u76EE",
  PIP_PROGRAM_IS_REQUIRED: "\u9700\u8981\u586B\u5199 PIP \u9879\u76EE",
  PIP_PROGRAMS: "PIP \u9879\u76EE",
  PIP_SEARCH: "PIP \u641C\u7D22",
  PIP_STATUS: "PIP \u72B6\u6001",
  PIP_TYPE: "PIP \u7C7B\u578B",
  PIP_TYPES: "PIP \u7C7B\u578B",
  PIPS: "PIP",
  PIPS_UNPAID_LABOR_ADDITIVE: "PIP \u672A\u8D54\u4ED8\u7684\u4EBA\u5DE5\u8865\u8D34",
  PLAN_DESCRIPTION: "\u8BA1\u5212\u8BF4\u660E",
  PLAN_END_DATE: "\u8BA1\u5212\u7ED3\u675F\u65E5\u671F",
  PLAN_ENDS: "\u8BA1\u5212\u7ED3\u675F",
  PLAN_NAME: "\u8BA1\u5212\u540D\u79F0",
  PLAN_NAME_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u8BA1\u5212\u540D\u79F0",
  PLAN_NAMES: "\u8BA1\u5212\u540D\u79F0",
  PLAN_START_DATE: "\u8BA1\u5212\u5F00\u59CB\u65E5\u671F",
  PLAN_STARTS: "\u8BA1\u5212\u5F00\u59CB",
  PLANNED_BY: "\u8BA1\u5212\u4EBA",
  PLANT: "\u5DE5\u5382",
  PLATE_REQUEST_INFORMATION: "\u724C\u7167\u8BF7\u6C42\u4FE1\u606F",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "\u8BF7\u9009\u62E9\u4E00\u4E2A\u603B\u8D26\u6237",
  PLEASE_SELECT_CLAIM_TYPE: "\u8BF7\u9009\u62E9\u7D22\u8D54\u7C7B\u578B",
  POLISH: "\u6CE2\u5170\u8BED",
  PORTUGUESE: "\u8461\u8404\u7259\u8BED",
  POSTAGE_DELIVERY_DATE: "\u90AE\u4EF6\u9001\u8FBE\u65E5\u671F",
  POSTAL_CODE: "\u90AE\u653F\u7F16\u7801",
  POSTAL_CODE_REQUIRED: "\u90AE\u653F\u7F16\u7801\u5FC5\u586B",
  POSTAL_TRACKING_NUMBER: "\u90AE\u653F\u8FFD\u8E2A\u7F16\u53F7",
  POTENTIAL_RESPONSIBLE_DEALER: "\u6F5C\u5728\u8D1F\u8D23\u7684\u7ECF\u9500\u5546",
  PRE_DELIVERY_INSPECTION: "\u4EA4\u8F66\u524D\u68C0\u67E5",
  PREFERRED_THEME: "\u9996\u9009\u4E3B\u9898",
  PREPARE_AUDIT: "\u51C6\u5907\u5BA1\u8BA1",
  PREPARED: "\u51C6\u5907\u65E5\u671F",
  PREPARING_AUDIT_FOR_WITH_DEALER: "\u51C6\u5907 {dealer} \u7684\u5BA1\u8BA1",
  PREVIOUS_AMOUNT_OF_USE: "\u5148\u524D\u4F7F\u7528\u91CF",
  PREVIOUS_INVOICE_NUMBER: "\u5148\u524D\u53D1\u7968\u53F7",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5148\u524D\u53D1\u7968\u53F7",
  PREVIOUS_MONTH: "\u4E0A\u4E2A\u6708",
  PRICE: "\u4EF7\u683C",
  PRICING_SUMMARY: "\u5B9A\u4EF7\u6C47\u603B",
  PRIMARY_ACTION: "\u4E3B\u8981\u64CD\u4F5C",
  PRIMARY_LANGUAGE: "\u4E3B\u8981\u8BED\u8A00",
  PRINT: "\u6253\u5370",
  PRINT_CLAIM: "\u6253\u5370\u7D22\u8D54",
  PRINT_REGISTRATION_FORM: "\u6253\u5370\u6CE8\u518C\u8868\u683C",
  PRINT_REGISTRATION_FORM_MESSAGE: "\u4EA7\u54C1\u5DF2\u6CE8\u518C\u7ED9\u9996\u4E2A\u6240\u6709\u8005\u3002\u60A8\u60F3\u73B0\u5728\u6253\u5370\u6CE8\u518C\u8868\u683C\u5417\uFF1F",
  PRINT_TO_PDF: "\u6253\u5370",
  PRIORITY: "\u4F18\u5148\u7EA7",
  PRNT_CLM: "\u663E\u793A\u7D22\u8D54",
  PROCESS_DATE: "\u5904\u7406\u65E5\u671F",
  PROCESSED: "\u5904\u7406\u65E5\u671F",
  PROCESSED_PART_REQUESTS: "\u5DF2\u5904\u7406\u7684\u96F6\u4EF6\u8BF7\u6C42",
  PROCESSING_STATUS: "\u5904\u7406\u72B6\u6001",
  PROCESSING_STATUS_DESCRIPTION: "\u5904\u7406\u72B6\u6001\u8BF4\u660E",
  PRODUCT_DETAILS: "\u4EA7\u54C1\u8BE6\u7EC6\u4FE1\u606F",
  PRODUCT_HIERARCHY: "\u4EA7\u54C1\u5C42\u7EA7",
  PRODUCT_INFORMATION: "\u4EA7\u54C1\u4FE1\u606F",
  PRODUCT_REGISTERED: "\u4EA7\u54C1\u5DF2\u6CE8\u518C",
  PRODUCT_REGISTRATION: "\u4EA7\u54C1\u6CE8\u518C",
  PRODUCT_REGISTRATION_PENDED: "\u4EA7\u54C1\u6CE8\u518C\u88AB\u5F85\u5B9A",
  PRODUCT_TRACKING: "\u4EA7\u54C1\u8DDF\u8E2A",
  PRODUCTS: "\u4EA7\u54C1",
  PRODUCTS_BY_CUSTOMER: "\u6309\u5BA2\u6237\u8FC7\u6EE4\u4EA7\u54C1",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "\u7531\u4E8E\u4E34\u65F6\u7CFB\u7EDF\u8FDE\u63A5\u95EE\u9898\uFF0C\u8FC7\u53BB\u7684PIN\u53EF\u80FD\u4F1A\u5728\u641C\u7D22\u7ED3\u679C\u4E2D\u4E22\u5931",
  PRODUCTS_WITH_COUNT: "\u4EA7\u54C1 ({count})",
  PROGRAM: "\u7A0B\u5E8F",
  PROGRAM_DESCRIPTION: "\u7A0B\u5E8F\u8BF4\u660E",
  PROGRAM_IS_REQUIRED: "\u7A0B\u5E8F\u540D\u79F0\u662F\u5FC5\u9700\u7684\u3002",
  PROGRAM_NAME: "\u7A0B\u5E8F\u540D\u79F0",
  PROGRAM_NAME_IS_REQUIRED: "\u7A0B\u5E8F\u540D\u79F0\u662F\u5FC5\u9700\u7684\u3002",
  PROGRAM_NUMBER: "\u8BA1\u5212\u7F16\u53F7",
  PRT: "\u4EA7\u54C1\u8DDF\u8E2A",
  PRTS: "\u4EA7\u54C1\u8DDF\u8E2A",
  PURCHASE_INFO: "\u91C7\u8D2D\u4FE1\u606F",
  PURCHASE_ORDER: "\u8D2D\u8D27\u8BA2\u5355\u53F7",
  PURCHASE_ORDER_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u8D2D\u8D27\u8BA2\u5355\u53F7",
  PURCHASER_TYPE: "\u8D2D\u4E70\u8005\u7C7B\u578B",
  PURCHASER_TYPE_REQUIRED: "\u8D2D\u4E70\u8005\u7C7B\u578B\u5FC5\u586B",
  PUSH_XML: "\u91CD\u65B0\u53D1\u9001XML",
  QTY: "\u6570\u91CF",
  QUALIFY_FOR_EMISSIONS: "\u7B26\u5408\u6392\u653E\u6761\u4EF6",
  QUANTITY: "\u6570\u91CF",
  QUANTITY_1: "\u6570\u91CF 1",
  QUANTITY_2: "\u6570\u91CF 2",
  QUANTITY_3: "\u6570\u91CF 3",
  QUANTITY_4: "\u6570\u91CF 4",
  QUANTITY_5: "\u6570\u91CF 5",
  QUANTITY_6: "\u6570\u91CF 6",
  QUANTITY_7: "\u6570\u91CF 7",
  QUANTITY_8: "\u6570\u91CF 8",
  QUANTITY_9: "\u6570\u91CF 9",
  QUANTITY_10: "\u6570\u91CF 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "\u67E5\u8BE2\u5FC5\u987B\u5305\u542B\u81F3\u5C11 3 \u4E2A\u5B57\u7B26",
  QUEST_DESC: "\u53EF\u7591\u63CF\u8FF0",
  QUESTIONABLE_PART: "\u6709\u95EE\u9898\u7684\u96F6\u4EF6",
  QUEUED: "\u6392\u961F",
  REASON_FOR_CHANGE: "\u66F4\u6539\u539F\u56E0",
  REASON_FOR_DEBIT: "\u6263\u6B3E\u539F\u56E0",
  REASON_FOR_MISSING_PLATE: "\u677F\u7F3A\u5931\u7684\u539F\u56E0",
  REASON_FOR_MISSING_PLATE_REQUIRED: "\u9700\u8981\u677F\u7F3A\u5931\u7684\u539F\u56E0",
  REASON_FOR_OVERRIDE: "\u66FF\u4EE3\u539F\u56E0",
  REASON_FOR_REFUSAL: "\u62D2\u7EDD\u539F\u56E0",
  REASON_FOR_RETURN: "\u9000\u8D27\u539F\u56E0",
  REASON_FOR_RETURN_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u9000\u8D27\u539F\u56E0",
  REASON_FOR_TRANSFER: "\u79FB\u4EA4\u539F\u56E0",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "\u79FB\u4EA4\u539F\u56E0\u5FC5\u987B\u5305\u542B\u5B57\u6BCD\u6570\u5B57\u5B57\u7B26",
  RECIPIENT_DEALER_OR_TCSM: "\u6536\u4EF6\u4EBA\uFF08\u7ECF\u9500\u5546\u6216TCSM\uFF09",
  RECIPIENT_MAILING: "\u90AE\u5BC4\u6536\u4EF6\u4EBA",
  RECONCILE: "\u6838\u9500",
  RECONCILE_CLAIM: "\u6838\u9500\u7D22\u8D54",
  RECONCILED: "\u6838\u9500",
  RECORD_AUDIT: "\u8BB0\u5F55\u5BA1\u8BA1",
  RECORD_AUDIT_FOR: "\u8BB0\u5F55 {dealer} \u7684\u5BA1\u8BA1",
  RECORDS_FOUND: "\u627E\u5230 {countToDisplay} \u6761\u8BB0\u5F55",
  RECOVERABLE_TAXES: "\u53EF\u62B5\u6263\u7A0E",
  RECOVERED: "\u8D54\u4ED8\u6BD4\u7387",
  RECOVERED_WITH_MISSED_ADDITIVES: "\u542B\u8865\u8D34\u635F\u5931\u7684\u8D54\u4ED8\u6BD4\u7387",
  RECOVERED_WITHOUT_ADDITIVES: "\u4E0D\u542B\u8865\u8D34\u7684\u8D54\u4ED8\u6BD4\u7387",
  RECOVERY: "\u8D54\u4ED8\u60C5\u51B5",
  RED_MUST_BE_LESS_THAN_YELLOW: "\u7EA2\u8272\u6307\u793A\u706F\u6570\u503C\u5FC5\u987B\u5C0F\u4E8E\u9EC4\u8272\u6307\u793A\u706F\u6570\u503C",
  REFERENCE_1: "\u53C2\u8003 1",
  REFERENCE_2: "\u53C2\u8003 2",
  REFERENCE_INFORMATION: "\u53C2\u8003\u4FE1\u606F",
  REFERENCE_NUMBER1: "\u53C2\u8003\u53F7 1",
  REFERENCE_NUMBER2: "\u53C2\u8003\u53F7 2",
  REGION: "\u5730\u533A",
  REGISTER: "\u6CE8\u518C",
  REGISTER_A_PRODUCT_BY_PIN: "\u901A\u8FC7 PIN \u6CE8\u518C\u4EA7\u54C1",
  REGISTER_A_PRODUCT_TO_ADD: "\u6CE8\u518C\u4EA7\u54C1\u5E76\u6DFB\u52A0\u5230\u7D22\u8D54\u7CFB\u7EDF",
  REGISTER_ANOTHER_PRODUCT: "\u6CE8\u518C\u53E6\u4E00\u4E2A\u4EA7\u54C1",
  REGISTER_PRODUCT: "\u6CE8\u518C\u4EA7\u54C1",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "\u6CE8\u518C\u4EA7\u54C1\u5E76\u6CE8\u518C\u4E0B\u4E00\u4E2A",
  REGISTERED: "\u6CE8\u518C\u65E5\u671F",
  REGISTRATION: "\u6CE8\u518C",
  REGISTRATION_DATE: "\u6CE8\u518C\u65E5\u671F",
  REGISTRATION_DATES: "\u767B\u8BB0\u65E5\u671F",
  REGISTRATION_FORM: "\u6CE8\u518C\u8868",
  REGISTRATION_HISTORY: "\u6CE8\u518C\u5386\u53F2\u8BB0\u5F55",
  REGISTRATION_NOT_ALLOWED: "\u8BE5\u4EA7\u54C1\u4E0D\u5141\u8BB8\u6CE8\u518C",
  REGISTRATION_REVIEW: "\u6CE8\u518C\u68C0\u67E5",
  REGISTRATION_REVIEW_TAB: "\u6CE8\u518C\u68C0\u67E5 ({count})",
  REGISTRATION_STATUS: "\u6CE8\u518C\u72B6\u6001",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "\u6CE8\u518C\u72B6\u6001\u4E0D\u80FD\u4E3A\u65B0",
  REGISTRATION_STATUS_REQUIRED: "\u6CE8\u518C\u72B6\u6001\u5FC5\u9700",
  REGISTRATION_SUCCESS: "\u6CE8\u518C\u6210\u529F",
  REGISTRATION_TYPE: "\u6CE8\u518C\u7C7B\u578B",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "\u6CE8\u518C\u7C7B\u578B\u4E0D\u80FD\u4E3A\u65B0",
  REGISTRATION_TYPE_REQUIRED: "\u6CE8\u518C\u7C7B\u578B\u5FC5\u586B",
  REGISTRATION_UPDATED_SUCCESSFULLY: "\u6CE8\u518C\u66F4\u65B0\u6210\u529F",
  REGISTRATIONS_REVIEW: "\u6CE8\u518C\u68C0\u67E5",
  REIMBURSED: "\u8D54\u4ED8",
  REIMBURSED_AMOUNT: "\u8D54\u4ED8\u91D1\u989D",
  REIMBURSED_PERCENTAGE: "\u8D54\u4ED8\u767E\u5206\u6BD4",
  REIMBURSED_PERCENTAGE_INDICATOR: "\u8D54\u4ED8\u767E\u5206\u6BD4\u6307\u793A\u706F",
  REIMBURSEMENT_DETAILS: "\u8D54\u4ED8\u8BE6\u7EC6\u4FE1\u606F",
  REIMBURSEMENT_PERCENTAGE: "\u8D54\u4ED8\u767E\u5206\u6BD4",
  REIMBURSEMENT_SUMMARY: "\u8D54\u4ED8\u603B\u7ED3",
  REJECT: "\u62D2\u7EDD",
  REJECT_LABOR_RATE: "\u62D2\u7EDD\u4EBA\u5DE5\u8D39\u7387",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "\u62D2\u7EDD\u7279\u6B8A\u7D22\u8D54",
  REJECTED: "\u62D2\u7EDD",
  REJECTED_APPEAL: "\u88AB\u62D2\u8BF7\u6C42",
  RELATIONSHIP: "\u5173\u7CFB",
  RELATIONSHIP_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5173\u7CFB",
  REMOVE_FILTER: "\u53D6\u6D88\u7B5B\u9009",
  REMOVE_FROM_AUDIT: "\u4ECE\u5BA1\u8BA1\u4E2D\u5220\u9664",
  REMOVE_LAYOUT: "\u5220\u9664\u5E03\u5C40",
  RENTAL_PINS: "\u79DF\u8D41PIN",
  REPAIR_DATE: "\u7EF4\u4FEE\u65E5\u671F",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "\u7EF4\u4FEE\u65E5\u671F\u4E0D\u53EF\u65E9\u4E8E\u6545\u969C\u65E5\u671F",
  REPAIR_NUMBER: "\u4FEE\u7406\u53F7",
  REPAIR_NUMBER_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u4FEE\u7406\u53F7",
  REPAIR_REPLACE_INDICATOR: "\u4FEE\u7406/\u66F4\u6362\u5206\u7C7B",
  REPAIRED: "\u7EF4\u4FEE\u65E5\u671F",
  REPAIRED_DATE: "\u7EF4\u4FEE\u65E5\u671F",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "\u7EF4\u4FEE\u65E5\u671F\u4E0D\u53EF\u65E9\u4E8E\u6545\u969C\u65E5\u671F",
  REPAIRED_DATE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7EF4\u4FEE\u65E5\u671F",
  REPORT_DATE: "\u62A5\u544A\u65E5\u671F",
  REPORT_NUMBER: "\u62A5\u544A\u53F7",
  REPORTS: "\u62A5\u544A",
  REQ_ADDL: "\u8C03\u6574\u7ED3\u7B97",
  REQUEST_DATE: "\u8BF7\u6C42\u65E5\u671F",
  REQUEST_DETAILS: "\u8BF7\u6C42\u8BE6\u60C5",
  REQUEST_DUPLICATE_PIN_PLATE: "\u8BF7\u6C42\u590D\u5236PIN\u724C",
  REQUEST_FORM: "\u7533\u8BF7\u8868",
  REQUEST_PIP_CODE: "\u7533\u8BF7 PIP \u4EE3\u7801",
  REQUEST_STATUS: "\u8BF7\u6C42\u72B6\u6001",
  REQUEST_SUBMITTED: "\u7533\u8BF7\u5DF2\u63D0\u4EA4",
  REQUEST_TYPE: "\u8BF7\u6C42\u7C7B\u578B",
  REQUEST_UPDATED_SUCCESSFULLY: "\u8BF7\u6C42\u5DF2\u6210\u529F\u66F4\u65B0",
  REQUEST_WARRANTY_CLAIM_DEBIT: "\u7533\u8BF7\u7D22\u8D54\u6263\u6B3E",
  REQUESTED: "\u7533\u8BF7\u503C",
  REQUESTED_BY: "\u7533\u8BF7\u4EBA",
  REQUESTED_DATE: "\u7533\u8BF7\u65E5\u671F",
  REQUESTED_DATES: "\u7533\u8BF7\u65E5\u671F",
  REQUESTED_DIAGNOSTIC_AMOUNT: "\u8BF7\u6C42\u7684\u8BCA\u65AD\u91D1\u989D",
  REQUESTED_DIAGNOSTIC_HOURS: "\u8BF7\u6C42\u7684\u8BCA\u65AD\u65F6\u95F4",
  REQUESTED_LABOR_AMOUNT: "\u7533\u8BF7\u7684\u5DE5\u65F6\u6570",
  REQUESTED_LABOR_HOURS: "\u7533\u8BF7\u7684\u5DE5\u65F6",
  REQUESTED_OTHER_CREDITS: "\u7533\u8BF7\u7684\u5176\u4ED6\u8D54\u4ED8",
  REQUESTED_PARTS: "\u7533\u8BF7\u7684\u96F6\u4EF6\u91D1\u989D",
  REQUESTED_REPAIR_AMOUNT: "\u8BF7\u6C42\u7684\u4FEE\u7406\u91D1\u989D",
  REQUESTED_REPAIR_HOURS: "\u8BF7\u6C42\u7684\u7EF4\u4FEE\u65F6\u95F4",
  REQUESTED_TRAVEL_TOTAL: "\u7533\u8BF7\u7684\u5DEE\u65C5\u603B\u8BA1",
  REQUESTER_TCSM: "\u7533\u8BF7\u4EBA(TCSM)",
  REQUESTER_TCSM_REQUIRED: "\u9700\u8981\u7533\u8BF7\u4EBA(TCSM)",
  REQUIRED: "\u5FC5\u9700",
  REQUIRED_CRITERIA: "\u5FC5\u586B\u6807\u51C6",
  REQUIRED_ITEMS: "\u5FC5\u9700\u9879\u76EE",
  RESEND_XML: "\u91CD\u65B0\u53D1\u9001XML",
  RESET: "\u91CD\u7F6E",
  RESPONDENT_INFORMATION: "\u56DE\u590D\u4FE1\u606F",
  RESPONSIBILITY_OF: "\u804C\u8D23",
  RESPONSIBLE_ACCOUNT: "\u8D23\u4EFB\u8D26\u6237",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "\u8D23\u4EFB\u8D26\u6237\u5FC5\u9700",
  RESPONSIBLE_DEALER: "\u8D1F\u8D23\u7ECF\u9500\u5546",
  RET: "\u9000\u56DE",
  RETAIL_INSTALL: "\u96F6\u552E/\u5B89\u88C5\u65E5\u671F",
  RETAIL_INSTALL_DATE: "\u96F6\u552E/\u5B89\u88C5\u65E5\u671F",
  RETAIL_INSTALL_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u96F6\u552E/\u5B89\u88C5\u65E5\u671F",
  RETAILER_NAME: "\u96F6\u552E\u5546\u540D\u79F0",
  RETAILER_NAME_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u96F6\u552E\u5546\u540D\u79F0",
  RETRY: "\u91CD\u8BD5",
  RETURN: "\u8FD4\u56DE",
  RETURN_LABOR_RATE: "\u8FD4\u56DE\u4EBA\u5DE5\u8D39\u7387",
  RETURN_REQUEST: "\u9000\u8D27\u7533\u8BF7",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "\u9000\u56DE\u7279\u6B8A\u7D22\u8D54",
  RETURN_STATUS: "\u8FD4\u56DE\u72B6\u6001",
  RETURNED: "\u9000\u56DE",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "\u9000\u8D27\u65E5\u671F\u4E0D\u53EF\u65E9\u4E8E\u7528\u6237\u63D0\u8F66\u65E5\u671F",
  RETURNED_DATE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u9000\u8D27\u65E5\u671F",
  REVIEW_DEALER_RECOMMENDATIONS: "\u662F\u5426\u786E\u5B9A\u8981\u6807\u8BB0\u8981\u67E5\u770B\u7684\u9488\u811A\uFF1F",
  REVISE: "\u4FEE\u8BA2",
  REVISED: "\u4FEE\u8BA2",
  ROLLING_12_CREDIT_AMOUNT: "\u7D2F\u8BA112 \u4E2A\u6708\u8D54\u4ED8\u989D",
  ROLLING_12_MONTHS: "\u7D2F\u8BA1 12 \u4E2A\u6708",
  RUN_REPORT: "\u8FD0\u884C\u62A5\u544A",
  RUSSIAN: "\u4FC4\u8BED",
  SAP_DOWN_WARNING: "\u4FDD\u4FEE\u7CFB\u7EDF\u529F\u80FD\u5DF2\u635F\u574F\u3002\u6211\u4EEC\u6B63\u5728\u52AA\u529B\u5C3D\u5FEB\u7EA0\u6B63\u8FD9\u4E00\u60C5\u51B5\u3002\u5237\u65B0\u6D4F\u89C8\u5668\u4EE5\u68C0\u67E5\u7CFB\u7EDF\u53EF\u7528\u6027\u3002",
  SAVE: "\u4FDD\u5B58",
  SAVE_AS_DRAFT: "\u53E6\u5B58\u4E3A\u8349\u7A3F",
  SAVE_AS_NEW_LAYOUT: "\u53E6\u5B58\u4E3A\u65B0\u5E03\u5C40",
  SAVE_AUDIT: "\u4FDD\u5B58\u5BA1\u8BA1",
  SAVE_CHANGES: "\u4FDD\u5B58\u66F4\u6539",
  SAVE_TO_VALIDATE: "\u4FDD\u5B58\u4EE5\u9A8C\u8BC1",
  SAVE_VALD: "\u4FDD\u5B58\u5E76\u786E\u8BA4",
  SAVE_VALIDATE: "\u4FDD\u5B58\u5E76\u786E\u8BA4",
  SEARCH: "\u641C\u7D22",
  SEARCH_BOX_PLACEHOLDER: "\u8F93\u5165 PIN\u3001\u5E8F\u5217\u53F7\u3001\u7D22\u8D54\u7F16\u53F7\u3001DTAC \u6848\u4F8B\u6216\u5BA2\u6237\u59D3\u540D",
  SEARCH_BY_CLAIM_TYPE: "\u8F93\u5165\u5B8C\u6574\u7684\u7D22\u8D54\u7C7B\u578B",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "\u7D22\u8D54\u641C\u7D22\u5FC5\u987B\u4E3A\u5B8C\u6574\u7684\u7D22\u8D54\u7C7B\u578B\uFF0C\u5B57\u7B26\u6570\u4ECB\u4E8E 4 \u5230 9 \u4E4B\u95F4",
  SEARCH_BY_FAILURE_PART_NUMBER: "\u8F93\u5165\u5B8C\u6574\u7684\u6545\u969C\u90E8\u4EF6\u53F7",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "\u7D22\u8D54\u641C\u7D22\u5FC5\u987B\u4E3A\u5B8C\u6574\u7684\u7D22\u8D54\u7C7B\u578B\uFF0C\u6700\u5C11\u4E3A 4 \u4E2A\u5B57\u7B26",
  SEARCH_BY_WORK_ORDER: "\u8F93\u5165\u5DE5\u4F5C\u901A\u77E5\u5355\uFF0C\u6700\u5C11\u4E3A 2 \u4E2A\u5B57\u7B26",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "\u5DE5\u5355\u641C\u7D22\u5FC5\u987B\u662F2\u4E2A\u5B57\u7B26",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "\u8F93\u5165\u5B8C\u6574\u7D22\u8D54\u7F16\u53F7",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "\u5FC5\u987B\u901A\u8FC7 4 \u81F3 9 \u4E2A\u5B57\u7B26\u7684\u5B8C\u6574\u7D22\u8D54\u7F16\u53F7\u6765\u641C\u7D22\u7D22\u8D54",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "\u8F93\u5165\u5B8C\u6574\u90E8\u4EF6\u5E8F\u5217\u53F7",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "\u90E8\u4EF6\u641C\u7D22\u5FC5\u987B\u586B\u5199\u5B8C\u6574\u5E8F\u5217\u53F7\uFF0C\u81F3\u5C11\u542B 1 \u4E2A\u5B57\u7B26",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "\u8F93\u5165PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "\u8F93\u5165\u5B8C\u6574\u578B\u53F7",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "\u5FC5\u987B\u901A\u8FC7 3 \u81F3 12 \u4E2A\u5B57\u7B26\u7684\u5B8C\u6574\u578B\u53F7\u6765\u641C\u7D22\u578B\u53F7",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "\u8F93\u5165 PIN\uFF0C\u6700\u5C11\u4E3A 6 \u4E2A\u5B57\u7B26",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "PIN \u641C\u7D22\u5B57\u7B26\u6570\u5FC5\u987B\u4ECB\u4E8E 6 \u5230 17 \u4E4B\u95F4",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "\u8F93\u5165 PIP \u53F7\uFF0C\u6700\u5C11 4 \u4E2A\u5B57\u7B26",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "PIP \u641C\u7D22\u5FC5\u987B\u662F 4 \u5230 12 \u4E2A\u5B57\u7B26",
  SEARCH_RESULTS_TAB: "\u641C\u7D22\u7ED3\u679C ({count})",
  SECOND_SHIP_TO_LOCATION: "\u7B2C\u4E8C\u6536\u8D27\u5730\u5740",
  SELECT: "\u9009\u62E9",
  SELECT_A_RANGE: "\u9009\u62E9\u8303\u56F4",
  SELECT_ALL: "\u5168\u9009",
  SELECT_AUTO_SUBMIT: "\u9009\u62E9\u81EA\u52A8\u63D0\u4EA4",
  SELECT_BRANCH: "\u9009\u62E9\u5206\u652F\u673A\u6784",
  SELECT_CLAIM_TYPE: "\u9009\u62E9\u7D22\u8D54\u7C7B\u578B",
  SELECT_COLUMNS: "\u9009\u62E9\u5217",
  SELECT_COUNTRY: "\u9009\u62E9\u56FD\u5BB6",
  SELECT_CSV_SEPARATOR: "\u9009\u62E9CSV\u5206\u9694\u7B26",
  SELECT_DATE_FORMAT: "\u9009\u62E9\u65E5\u671F\u683C\u5F0F",
  SELECT_DEALERS_AND_STATUS: "\u9009\u62E9\u7ECF\u9500\u5546\u548C\u72B6\u6001",
  SELECT_DECIMAL_FORMAT: "\u9009\u62E9\u5341\u8FDB\u5236\u683C\u5F0F",
  SELECT_DISPLAY_FORMAT: "\u9009\u62E9\u663E\u793A\u683C\u5F0F",
  SELECT_FACTORY: "\u9009\u62E9\u5DE5\u5382",
  SELECT_LANGUAGE: "\u9009\u62E9\u8BED\u8A00",
  SELECT_LAYOUT: "\u9009\u62E9\u5E03\u5C40",
  SELECT_PIP_CODE: "\u9009\u62E9 PIP \u4EE3\u7801",
  SELECT_PLAN_NAMES: "\u9009\u62E9\u8BA1\u5212\u540D\u79F0",
  SELECT_SERVICE_INTERVAL_TYPES: "\u9009\u62E9\u670D\u52A1\u95F4\u9694\u7C7B\u578B",
  SELECT_SORT_BY: "\u9009\u62E9\u6392\u5E8F",
  SELECT_SORT_DIRECTION: "\u9009\u62E9\u6392\u5E8F\u987A\u5E8F",
  SELECT_STATE: "\u9009\u62E9\u7701\u5E02",
  SELECT_STATUS: "\u9009\u62E9\u72B6\u6001",
  SELECT_TERRITORY: "\u9009\u62E9\u5730\u533A",
  SELECT_THEME: "\u9009\u62E9\u4E3B\u9898",
  SELECT_TIME_ZONE: "\u9009\u62E9\u65F6\u533A",
  SELECT_VALUES_TO_APPROVE: "\u9009\u62E9\u8981\u6279\u51C6\u7684\u6570\u503C",
  SELECTED_COLUMNS: "\u9009\u5B9A\u7684\u5217",
  SELECTED_FOR_AUDIT: "\u9009\u62E9\u7528\u4E8E\u5BA1\u8BA1",
  SELECTED_FOR_AUDIT_VSR: "\u5173\u4E8E\u6B64\u7D22\u8D54\u6240\u9700\u7684\u5BA1\u8BA1\u6587\u6863\u548C\u9644\u4EF6\uFF0C\u8BF7\u53C2\u89C1DTAC\u89E3\u51B3\u65B9\u6848221475",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "\u9009\u62E9\u591A\u4E2A\u5E10\u6237\u548C\u4FDD\u4FEE\u7C7B\u578B\u5F71\u54CD\u7CFB\u7EDF\u54CD\u5E94\u901F\u5EA6",
  SEND: "\u53D1\u9001",
  SERIAL_NUMBER: "\u5E8F\u5217\u53F7",
  SERIAL_NUMBER_INVOICE_NUMBER: "\u5E8F\u5217\u53F7 / \u53D1\u7968\u53F7",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "\u670D\u52A1\u5668\u7B49\u5F85\u65F6\u95F4\u8FC7\u957F\uFF0C\u8BF7\u6C42\u5DF2\u88AB\u53D6\u6D88\u3002\u8BF7\u8F93\u5165\u66F4\u5177\u4F53\u7684\u8BF7\u6C42\u6216\u7A0D\u540E\u91CD\u8BD5\u3002",
  SERVICE_DATE_IS_REQUIRED: "\u9700\u8981\u670D\u52A1\u65E5\u671F",
  SERVICE_INTERVAL: "\u670D\u52A1\u95F4\u9694",
  SERVICE_INTERVAL_BEGIN_DATE: "\u670D\u52A1\u95F4\u9694\u5F00\u59CB\u65E5\u671F",
  SERVICE_INTERVAL_END_DATE: "\u670D\u52A1\u95F4\u9694\u7ED3\u675F\u65E5\u671F",
  SERVICE_INTERVAL_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u670D\u52A1\u95F4\u9694",
  SERVICE_INTERVAL_NUMBER: "\u670D\u52A1\u95F4\u9694\u53F7",
  SERVICE_INTERVAL_STATUS: "\u670D\u52A1\u95F4\u9694\u72B6\u6001",
  SERVICE_INTERVAL_TYPE: "\u670D\u52A1\u95F4\u9694\u7C7B\u578B",
  SERVICE_INTERVAL_TYPES: "\u670D\u52A1\u95F4\u9694\u7C7B\u578B",
  SERVICE_PART: "\u670D\u52A1\u96F6\u4EF6",
  SERVICE_UNAVAILABLE: "\u670D\u52A1\u4E0D\u53EF\u7528",
  SERVICED: "\u670D\u52A1\u65E5\u671F",
  SERVICED_DATE_IS_REQUIRED: "\u670D\u52A1\u65E5\u671F\u662F\u5FC5\u9700\u7684\u3002",
  SERVICED_IS_REQUIRED: "\u670D\u52A1\u65E5\u671F\u662F\u5FC5\u9700\u7684\u3002",
  SET_AS_DEFAULT: "\u8BBE\u4E3A\u9ED8\u8BA4",
  SETTINGS: "\u4E2A\u4EBA\u8BBE\u7F6E",
  SETTLED: "\u7ED3\u7B97\u65E5\u671F",
  SETTLEMENT_NO_REGISTRATION: "\u5DF2\u7ED3\u7B97\uFF0C\u672A\u6CE8\u518C",
  SETUP: "\u8BBE\u7F6E",
  SETUP_DATE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u8BBE\u7F6E\u65E5\u671F",
  SETUP_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u8BBE\u7F6E\u65E5\u671F",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "\u6536\u8D27\u65B9",
  SHIPPED: "\u53D1\u8D27\u65E5\u671F",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "\u53D1\u8D27\u4FE1\u606F/\u7279\u6B8A\u8BF4\u660E",
  SHIPPING_INSTRUCTIONS: "\u53D1\u8D27\u8BF4\u660E",
  SHORT_TEXT: "\u77ED \u6587\u672C",
  SHORT_TEXT_IS_REQUIRED: "\u9700\u8981\u77ED\u6587\u5B57",
  SHOW_ALL: "\u663E\u793A\u6240\u6709 ({count})",
  SHOW_EXCLUDED: "\u663E\u793A\u9664\u5916PIP",
  SHOW_MORE: "\u663E\u793A\u66F4\u591A",
  SHOW_MORE_GROUPS: "\u518D\u663E\u793A {countToDisplay} \u7EC4",
  SHOW_RED_IF_LESS_THAN: "\u5C0F\u4E8E\u4EE5\u4E0B\u503C\u5219\u663E\u793A\u7EA2\u8272",
  SHOW_REIMBURSED_AMOUNT: "\u663E\u793A\u8D54\u4ED8\u91D1\u989D",
  SHOW_REIMBURSED_PERCENTAGE: "\u663E\u793A\u8D54\u4ED8\u767E\u5206\u6BD4",
  SHOW_YELLOW_IF_LESS_THAN: "\u5C0F\u4E8E\u4EE5\u4E0B\u503C\u5219\u663E\u793A\u9EC4\u8272",
  SIGN_IN_REQUIRED: "\u767B\u5F55",
  SIGN_OUT: "\u767B\u51FA",
  SKIP_AUDIT: "\u8DF3\u8FC7\u5BA1\u6838",
  SKIP_AUDIT_SUCCESS: "\u5DF2\u8DF3\u8FC7\u5BA1\u6838\uFF0C\u5230\u671F\u65E5\u5C06\u5728\u5C06\u6765",
  SOME_PARTS_RETURNED: "\u67D0\u4E9B\u96F6\u4EF6\u9000\u56DE",
  SORT_BY: "\u6392\u5E8F\u65B9\u5F0F",
  SPANISH: "\u897F\u73ED\u7259\u8BED",
  SPECIAL_ALLOWANCE: "\u7279\u6B8A\u7D22\u8D54",
  SPECIAL_ALLOWANCE_CALCULATION: "\u7279\u6B8A\u7D22\u8D54\u8BA1\u7B97",
  SPECIAL_ALLOWANCE_CLAIM: "\u7279\u6B8A\u7D22\u8D54\u7533\u8BF7",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "\u7279\u6B8A\u7D22\u8D54\u72B6\u6001",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "\u7279\u6B8A\u7D22\u8D54\u72B6\u6001",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "\u7279\u6B8A\u7D22\u8D54\u72B6\u6001\u5DF2\u66F4\u65B0",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "\u7279\u6B8A\u7D22\u8D54 - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "\u7279\u6B8A\u7D22\u8D54 ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "\u7279\u6B8A\u7D22\u8D54\u5206\u644A\u91D1\u989D",
  SPECIAL_ALLOWANCE_DESCRIPTION: "\u7279\u6B8A\u7D22\u8D54\u8BF4\u660E",
  SPECIAL_ALLOWANCE_TYPE: "\u7279\u6B8A\u7D22\u8D54\u7C7B\u578B",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u7279\u6B8A\u7D22\u8D54\u7C7B\u578B",
  SPECIAL_INSTRUCTIONS: "\u7279\u6B8A\u8BF4\u660E",
  SPG: "SPG",
  SPGS: "SPG",
  STANDARD_VIEW: "\u6807\u51C6\u89C6\u56FE",
  START_AMOUNT_OF_USE: "\u5F00\u59CB\u4F7F\u7528\u91CF",
  STARTS: "\u5F00\u59CB",
  STARTS_WITH: "\u5F00\u59CB\u4E8E",
  STATE: "\u7701\u4EFD",
  STATE_PROVINCE: "\u5DDE/\u7701",
  STATE_PROVINCE_REQUIRED: "\u8981\u6C42\u7684\u5DDE/\u7701",
  STATUS: "\u72B6\u6001",
  STATUS_CHANGE_REQUEST: "\u72B6\u6001\u53D8\u66F4\u7533\u8BF7",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "\u72B6\u6001\u53D8\u66F4\u7533\u8BF7\u521B\u5EFA\u6210\u529F",
  STATUS_FOR: "{pin} \u7684\u72B6\u6001",
  STATUS_INDICATOR: "\u673A\u5668\u4EA4\u4ED8\u65F6\u72B6\u6001",
  STATUS_REASON: "\u72B6\u6001\u539F\u56E0",
  STOLEN_DATE: "\u88AB\u76D7\u65E5\u671F",
  STORE: "\u95E8\u5E97\u53F7",
  STORE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u95E8\u5E97\u53F7",
  STORE_NUMBER_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u95E8\u5E97\u53F7",
  STREET_1: "\u8857\u9053 1",
  STREET_2: "\u8857\u9053 2",
  SUB: "\u63D0\u4EA4",
  SUB_CLAIM_TYPE: "\u5B50\u7D22\u8D54\u7C7B\u578B",
  SUB_TYPE: "\u4E9A\u578B",
  SUBMISSION_DATE: "\u63D0\u4EA4\u65E5\u671F",
  SUBMIT: "\u63D0\u4EA4",
  SUBMIT_AUDIT: "\u63D0\u4EA4\u5BA1\u8BA1",
  SUBMIT_AUDIT_FOR: "\u63D0\u4EA4 {dealer} \u7684\u5BA1\u8BA1",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "\u63D0\u4EA4 {claimNumber} \u7684\u5168\u90E8\u6263\u6B3E",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "\u63D0\u4EA4 {claimNumber} \u7684\u90E8\u5206\u6263\u6B3E",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "\u63D0\u4EA4 {claimNumber} \u7684\u501F\u65B9\u767E\u5206\u6BD4\u7D22\u8D54",
  SUBMIT_REQUEST: "\u63D0\u4EA4\u8BF7\u6C42",
  SUBMITTED: "\u5DF2\u63D0\u4EA4",
  SUBMITTED_AVAILABLE_TO_EDIT: "\u5DF2\u63D0\u4EA4 (\u53EF\u7F16\u8F91)",
  SUCCESS: "\u6210\u529F",
  SUCCESS_MESSAGE_TITLE: "\u4E00\u9879\u64CD\u4F5C\u6210\u529F\uFF1A",
  SUCCESS_MESSAGES_TITLE: "\u591A\u9879\u64CD\u4F5C\u6210\u529F\uFF1A",
  SUPPLIER_WARRANTY: "\u4F9B\u5E94\u5546\u4FDD\u4FEE",
  SURVEY_QUESTIONS: "\u8C03\u67E5\u95EE\u9898",
  SUSPENDED: "\u6682\u505C",
  SWEDISH: "\u745E\u5178\u8BED",
  SYSTEM_SELECTED_CLAIMS: "\u7CFB\u7EDF\u9009\u62E9\u7684\u7D22\u8D54",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "\u7CFB\u7EDF\u9009\u62E9\u7684\u7D22\u8D54 ({count})",
  TABM: "TABM",
  TAX: "\u7A0E",
  TCSM: "TCSM",
  TECH_ID: "\u6280\u672F\u4EBA\u5458 ID",
  TERMINATED: "\u5DF2\u7EC8\u6B62",
  TERMINATES: "\u7EC8\u6B62\u65E5\u671F",
  TERRITORY: "\u5730\u533A",
  TEST: "\u6D4B\u8BD5",
  TEST_RESULTS_CODE: "\u6D4B\u8BD5\u7ED3\u679C\u4EE3\u7801",
  THEME: "\u4E3B\u9898",
  TIME_LIMIT: "\u65F6\u95F4\u9650\u5236",
  TIME_ZONE: "\u65F6\u533A",
  TITLE: "\u6807\u9898",
  TITLE_IS_REQUIRED: "\u6807\u9898\u4E3A\u5FC5\u586B\u9879",
  TO: "\u81F3",
  TODAY: "\u5F53\u65E5",
  TOO_MANY_RESULTS: "\u60A8\u7684\u8BF7\u6C42\u8FD4\u56DE\u7684\u7ED3\u679C\u592A\u591A\u3002 \u8BF7\u7F29\u5C0F\u641C\u7D22\u8303\u56F4\u5E76\u91CD\u8BD5\u3002",
  TOTAL: "\u603B\u8BA1",
  TOTAL_AMOUNT: "\u603B\u8BA1",
  TOTAL_APPROVED: "\u6279\u590D\u603B\u8BA1",
  TOTAL_APPROVED_CLAIM_VALUE: "\u6279\u51C6\u7684\u7D22\u8D54\u503C\u603B\u8BA1",
  TOTAL_APPROVED_INCLUDING_TAXES: "\u6279\u51C6\u7684\u542B\u7A0E\u603B\u989D",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "\u6279\u51C6\u7684\u4E0D\u542B\u8865\u8D34\u603B\u989D",
  TOTAL_CONTRIBUTION: "\u603B\u5206\u644A\u91D1\u989D",
  TOTAL_REIMBURSED: "\u603B\u8D54\u4ED8",
  TOTAL_REIMBURSED_WITH_CURRENCY: "\u603B\u8D54\u4ED8 ({currency})",
  TOTAL_REQUESTED: "\u7533\u8BF7\u603B\u8BA1",
  TOTAL_REQUESTED_CLAIM_VALUE: "\u7533\u8BF7\u7684\u7D22\u8D54\u503C\u603B\u8BA1",
  TOTAL_UNPAID: "\u672A\u8D54\u4ED8\u603B\u8BA1",
  TRACKING_NUMBER: "\u8DDF\u8E2A\u7F16\u53F7",
  TRANSFER: "\u79FB\u4EA4",
  TRANSFER_APPROVALS: "\u79FB\u4EA4\u6279\u51C6",
  TRANSFER_APPROVALS_TAB: "\u79FB\u4EA4\u6279\u51C6 ({count})",
  TRANSFER_CREATED: "\u5DF2\u521B\u5EFA\u79FB\u4EA4",
  TRANSFER_DEALER_RECOMMENDATIONS: "\u4F60\u786E\u5B9A\u8981\u628A\u522B\u9488\u8F6C\u7ED9\u5176\u4ED6\u7ECF\u9500\u5546\u5417\uFF1F",
  TRANSFER_UPDATED_SUCCESSFULLY: "\u79FB\u4EA4\u66F4\u65B0\u6210\u529F",
  TRANSFERS: "\u79FB\u4EA4",
  TRAVEL: "\u5DEE\u65C5",
  TURKISH: "\u571F\u8033\u5176\u8BED",
  TWO_PERCENT_WITHHOLD_VALUE: "2\uFF05\u6263\u538B\u503C",
  TYPE: "\u7C7B\u578B",
  TYPES: "\u7C7B\u578B",
  UNABLE_TO_CONTACT_THE_SERVER: "\u65E0\u6CD5\u8FDE\u63A5\u670D\u52A1\u5668",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "\u65E0\u6CD5\u52A0\u8F7D\u5BA2\u6237\u8BE6\u7EC6\u4FE1\u606F",
  UNDO: "\u64A4\u6D88",
  UNDO_REGISTRATION: "\u64A4\u9500\u6CE8\u518C",
  UNDO_REGISTRATION_SUCCESSFULL: "\u64A4\u9500\u6CE8\u518C\u6210\u529F",
  UNIT: "\u5355\u4F4D",
  UNIT_1: "\u5355\u4F4D 1",
  UNIT_2: "\u5355\u4F4D 2",
  UNIT_3: "\u5355\u4F4D 3",
  UNIT_OF_MEASURE: "\u8BA1\u91CF\u5355\u4F4D",
  UNPAID_LABOR: "\u672A\u8D54\u4ED8\u5DE5\u65F6",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "\u672A\u8D54\u4ED8\u7684\u4EBA\u5DE5\u8865\u8D34 - \u4E0D\u5305\u62EC PIP",
  UNPAID_LABOR_ADDITIVES_PIPS: "\u672A\u8D54\u4ED8\u7684\u4EBA\u5DE5\u8865\u8D34 - PIP",
  UNPAID_OTHER_CREDITS: "\u672A\u8D54\u4ED8\u7684\u5176\u4ED6\u8D54\u4ED8\u9879",
  UNPAID_PARTS: "\u672A\u8D54\u4ED8\u96F6\u4EF6",
  UNPAID_PARTS_ADDITIVE: "\u672A\u8D54\u4ED8\u7684\u96F6\u4EF6\u8865\u8D34",
  UNPAID_TRAVEL: "\u672A\u8D54\u4ED8\u5DEE\u65C5",
  UNSUB: "\u7F16\u8F91",
  UNSUBMIT_CLAIM: "\u7F16\u8F91\u7D22\u8D54\u5355",
  UPDATE_CUSTOMER_INFORMATION: "\u66F4\u65B0\u5BA2\u6237\u4FE1\u606F",
  UPDATE_LABOR_RATES: "\u66F4\u65B0\u5DE5\u65F6\u8D39\u7387",
  UPDATE_LAYOUT: "\u66F4\u65B0\u5E03\u5C40",
  UPDATE_MACHINE_STATUS: "\u66F4\u65B0\u673A\u5668\u72B6\u6001",
  UPDATE_MACHINE_STATUS_HISTORY: "\u66F4\u65B0\u673A\u5668\u72B6\u6001\u5386\u53F2\u8BB0\u5F55",
  UPDATE_REGISTRATION: "\u66F4\u65B0\u6CE8\u518C",
  UPDATE_SELECTED: "\u66F4\u65B0\u9009\u5B9A",
  UPDATED: "\u66F4\u65B0\u65E5\u671F",
  UPDATED_BY: "\u66F4\u65B0\u8005",
  UPLOAD_DOCUMENT: "\u4E0A\u4F20\u6587\u6863",
  UPTIME_ASSURANCE: "\u6B63\u5E38\u8FD0\u884C\u65F6\u95F4\u4FDD\u8BC1",
  USEFUL_LINKS: "\u6709\u7528\u7684\u94FE\u63A5",
  USER: "\u7528\u6237",
  USER_PREFERENCES_UPDATED: "\u7528\u6237\u504F\u597D\u8BBE\u7F6E\u5DF2\u66F4\u65B0",
  USER_SELECTED: "\u7528\u6237\u9009\u62E9",
  USER_SELECTED_CLAIMS_WITH_COUNT: "\u7528\u6237\u9009\u62E9\u7684\u7D22\u8D54 ({count})",
  USERS_INFORMATION: "\u7528\u6237\u4FE1\u606F",
  VALIDATE: "\u786E\u8BA4",
  VALIDATE_CLAIM: "\u786E\u8BA4\u7D22\u8D54",
  VALUE: "\u503C",
  VALUE_OF_REPAIR: "\u4FEE\u7406\u503C",
  VIEW_CLAIM: "\u67E5\u770B\u7D22\u8D54",
  VIEW_DETAILS: "\u67E5\u770B\u8BE6\u7EC6\u4FE1\u606F",
  VIEW_OPEN_PIPS: "\u67E5\u770B\u672A\u7ED3 PIP",
  VIEW_PIP: "\u67E5\u770B PIP",
  VIEW_PRODUCTS: "\u67E5\u770B\u4EA7\u54C1",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "\u67E5\u770B\u4EA7\u54C1\u548C\u66F4\u65B0\u4FE1\u606F",
  VIEW_UPDATE: "\u67E5\u770B/\u66F4\u65B0",
  VSR_MESSAGES: "VSR \u6D88\u606F",
  WAITING_FOR_DLR_INV: "\u7B49\u5F85\u7ECF\u9500\u5546\u53D1\u7968",
  WAITING_FOR_INVOICE: "\u7B49\u5F85\u53D1\u7968 ({count})",
  WAITING_SINCE: "\u7B49\u5F85\u59CB\u4E8E",
  WARNING_MESSAGE_TITLE: "\u5DF2\u53D1\u9001\u4E00\u4E2A\u8B66\u544A\uFF1A",
  WARNING_MESSAGES: "\u8B66\u544A\u4FE1\u606F",
  WARNING_MESSAGES_TITLE: "\u5DF2\u53D1\u9001\u591A\u4E2A\u8B66\u544A\uFF1A",
  WARRANTY: "\u4FDD\u4FEE",
  WARRANTY_ADMIN: "\u4FDD\u4FEE\u7BA1\u7406",
  WARRANTY_CLAIM_TYPE: "\u4FDD\u4FEE\u7D22\u8D54\u7C7B\u578B",
  WARRANTY_COVERAGE: "\u4FDD\u4FEE\u8303\u56F4",
  WARRANTY_EXPIRATION: "\u4FDD\u4FEE\u5230\u671F",
  WARRANTY_TYPE: "\u4FDD\u4FEE\u7C7B\u578B",
  WARRANTY_TYPES: "\u4FDD\u4FEE\u7C7B\u578B",
  WEAR_PARTS: "\u78E8\u635F\u90E8\u4EF6",
  WEAR_PARTS_COVERAGE: "\u78E8\u635F\u90E8\u4EF6\u8986\u76D6",
  WELCOME: "\u6B22\u8FCE",
  WIP: "\u8FDB\u884C\u4E2D\u7684\u5DE5\u4F5C",
  WITH_ADDITIVES: "\u542B\u8865\u8D34",
  WITNESS_FIRST_NAME: "\u89C1\u8BC1\u4EBA\u7684\u540D",
  WITNESS_LAST_NAME: "\u89C1\u8BC1\u4EBA\u7684\u59D3",
  WORK_ORDER: "\u5DE5\u5355",
  WORK_ORDER_NUMBER: "\u5DE5\u5355\u53F7",
  WORK_ORDER_ONE: "\u5DE5\u5355 1",
  WORK_ORDER_ONE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5DE5\u5355 1",
  WORK_ORDER_THREE: "\u5DE5\u5355 3",
  WORK_ORDER_THREE_IS_REQUIRED: "\u9700\u8981\u586B\u5199\u5DE5\u5355 3",
  WORK_ORDER_TWO: "\u5DE5\u5355 2",
  WORK_REPAIR_ORDER: "\u7EF4\u4FEE\u5DE5\u5355",
  YES: "\u662F",
  YES_LOWERCASE: "\u662F"
});